export const AuthActions = {
  THERAPIST_LOGIN_REQUEST: 'THERAPIST_LOGIN_REQUEST',
  THERAPIST_LOGIN_SUCCESS: 'THERAPIST_LOGIN_SUCCESS',
  THERAPIST_LOGIN_FAILURE: 'THERAPIST_LOGIN_FAILURE',
  THERAPIST_LOGIN_RESET: 'THERAPIST_LOGIN_RESET',
  THERAPIST_LOGOUT_REQUEST: 'THERAPIST_LOGOUT_REQUEST',
  THERAPIST_LOGOUT_SUCCESS: 'THERAPIST_LOGOUT_SUCCESS',
  THERAPIST_LOGOUT_FAILURE: 'THERAPIST_LOGOUT_FAILURE',
  THERAPIST_LOGOUT_RESET: 'THERAPIST_LOGOUT_RESET',
  REQUEST_SET_PASSWORD: 'REQUEST_SET_PASSWORD',
  SUCCESS_SET_PASSWORD: 'SUCCESS_SET_PASSWORD',
  FAILURE_SET_PASSWORD: 'FAILURE_SET_PASSWORD',
  RESET_SET_PASSWORD: 'RESET_SET_PASSWORD',
  TOKEN_FIRST_TIME: 'TOKEN_FIRST_TIME',

  AUTO_GENERATE_PASSWORD: 'AUTO_GENERATE_PASSWORD',
  AUTO_GENERATE_PASSWORD_SUCCESS: 'AUTO_GENERATE_PASSWORD_SUCCESS',
  AUTO_GENERATE_PASSWORD_FAILURE: 'AUTO_GENERATE_PASSWORD_FAILURE',
  AUTO_GENERATE_PASSWORD_RESET: 'AUTO_GENERATE_PASSWORD_RESET',
  AUTO_GENERATE_PASSWORD_LOADING: 'AUTO_GENERATE_PASSWORD_LOADING',

  POST_RESET_PASSWORD_REQUEST: 'POST_RESET_PASSWORD_REQUEST',
  POST_RESET_PASSWORD_SUCCESS: 'POST_RESET_PASSWORD_SUCCESS',
  POST_RESET_PASSWORD_FAILURE: 'POST_RESET_PASSWORD_FAILURE',
  POST_RESET_PASSWORD_RESET: 'POST_RESET_PASSWORD_RESET',
  POST_RESET_PASSWORD_LOADING: 'POST_RESET_PASSWORD_LOADING',
  THERAPIST_FACILITY_NOT_FOUND: 'THERAPIST_FACILITY_NOT_FOUND',
};

export const therapyPlanningAction = {
  GET_PLAN_OF_CARE_REQUEST: 'GET_PLAN_OF_CARE_REQUEST',
  GET_PLAN_OF_CARE_SUCCESS: 'GET_PLAN_OF_CARE_SUCCESS',
  GET_PLAN_OF_CARE_FAILURE: 'GET_PLAN_OF_CARE_FAILURE',
  GET_PLAN_OF_CARE_LOADING: 'GET_PLAN_OF_CARE_LOADING',

  CHECK_THERAPY_PLANNING_PLAN_MINUTES_REQUEST: 'CHECK_THERAPY_PLANNING_PLAN_MINUTES_REQUEST',
  CHECK_THERAPY_PLANNING_PLAN_MINUTES_SUCCESS: 'CHECK_THERAPY_PLANNING_PLAN_MINUTES_SUCCESS',
  CHECK_THERAPY_PLANNING_PLAN_MINUTES_FAILURE: 'CHECK_THERAPY_PLANNING_PLAN_MINUTES_FAILURE',
  CHECK_THERAPY_PLANNING_PLAN_MINUTES_RESET: 'CHECK_THERAPY_PLANNING_PLAN_MINUTES_RESET',
  CHECK_THERAPY_PLANNING_PLAN_MINUTES_LOADING: 'CHECK_THERAPY_PLANNING_PLAN_MINUTES_LOADING',

  GET_THERAPY_PLANNING_PATIENT_REQUEST: 'GET_THERAPY_PLANNING_PATIENT_REQUEST',
  GET_THERAPY_PLANNING_PATIENT_SUCCESS: 'GET_THERAPY_PLANNING_PATIENT_SUCCESS',
  GET_THERAPY_PLANNING_PATIENT_FAILURE: 'GET_THERAPY_PLANNING_PATIENT_FAILURE',

  GET_PATIENT_THERAPY_PLANNING_REQUEST: 'GET_PATIENT_THERAPY_PLANNING_REQUEST',
  GET_PATIENT_THERAPY_PLANNING_SUCCESS: 'GET_PATIENT_THERAPY_PLANNING_SUCCESS',
  GET_PATIENT_THERAPY_PLANNING_FAILURE: 'GET_PATIENT_THERAPY_PLANNING_FAILURE',
  GET_PATIENT_THERAPY_PLANNING_LOADING: 'GET_PATIENT_THERAPY_PLANNING_LOADING',
  GET_PATIENT_THERAPY_PLANNING_RESET: 'GET_PATIENT_THERAPY_PLANNING_RESET',

  GET_MDS_ASSESSMENT_REQUEST: 'GET_MDS_ASSESSMENT_REQUEST',
  GET_MDS_ASSESSMENT_SUCCESS: 'GET_MDS_ASSESSMENT_SUCCESS',
  GET_MDS_ASSESSMENT_FAILURE: 'GET_MDS_ASSESSMENT_FAILURE',
  GET_MDS_ASSESSMENT_LOADING: 'GET_MDS_ASSESSMENT_LOADING',
  CREATE_ASSESSMENT_REQUEST: 'CREATE_ASSESSMENT_REQUEST',
  CREATE_ASSESSMENT_SUCCESS: 'CREATE_ASSESSMENT_SUCCESS',
  CREATE_ASSESSMENT_FAILURE: 'CREATE_ASSESSMENT_FAILURE',
  CREATE_ASSESSMENT_LOADING: 'CREATE_ASSESSMENT_LOADING',
  RESET_CREATE_ASSESSMENT: 'RESET_CREATE_ASSESSMENT',
  UPDATE_ASSESSMENT_REQUEST: 'UPDATE_ASSESSMENT_REQUEST',
  UPDATE_ASSESSMENT_SUCCESS: 'UPDATE_ASSESSMENT_SUCCESS',
  UPDATE_ASSESSMENT_FAILURE: 'UPDATE_ASSESSMENT_FAILURE',
  RESET_UPDATE_ASSESMENT: 'RESET_UPDATE_ASSESSMENT',
  GET_ASSESSMENT_REQUEST: 'GET_ASSESSMENT_REQUEST',
  GET_ASSESSMENT_SUCCESS: 'GET_ASSESSMENT_SUCCESS',
  GET_ASSESSMENT_FAILURE: 'GET_ASSESSMENT_FAILURE',
  GET_ASSESSMENT_LOADING: 'GET_ASSESSMENT_LOADING',
  GET_THERAPY_PLANNING_REQUEST: 'GET_THERAPY_PLANNING_REQUEST',
  GET_THERAPY_PLANNING_SUCCESS: 'GET_THERAPY_PLANNING_SUCCESS',
  GET_THERAPY_PLANNING_CANCEL_TOKEN: 'GET_THERAPY_PLANNING_CANCEL_TOKEN',
  GET_THERAPY_PLANNING_FAILURE: 'GET_THERAPY_PLANNING_FAILURE',
  GET_THERAPY_PLANNING_LOADING: 'GET_THERAPY_PLANNING_LOADING',
  UPDATE_THERAPY_PLANNING_REQUEST: 'UPDATE_THERAPY_PLANNING_REQUEST',
  UPDATE_THERAPY_PLANNING_SUCCESS: 'UPDATE_THERAPY_PLANNING_SUCCESS',
  UPDATE_THERAPY_PLANNING_FAILURE: 'UPDATE_THERAPY_PLANNING_FAILURE',
  UPDATE_THERAPY_PLANNING_LOADING: 'UPDATE_THERAPY_PLANNING_LOADING',

  RESET_UPDATE_THERAPY_PLANNING_REQUEST: 'RESET_UPDATE_THERAPY_PLANNING_REQUEST',

  //authorization
  GET_CPT_CODE_BY_DISCIPLINE_REQUEST: 'GET_CPT_CODE_BY_DISCIPLINE_REQUEST',
  GET_CPT_CODE_BY_DISCIPLINE_SUCCESS: 'GET_CPT_CODE_BY_DISCIPLINE_SUCCESS',
  GET_CPT_CODE_BY_DISCIPLINE_FAILURE: 'GET_CPT_CODE_BY_DISCIPLINE_FAILURE',
  GET_CPT_CODE_BY_DISCIPLINE_LOADER: 'GET_CPT_CODE_BY_DISCIPLINE_LOADER',
  GET_CPT_CODE_BY_DISCIPLINE_RESET: 'GET_CPT_CODE_BY_DISCIPLINE_RESET',

  //edit authorization

  EDIT_AUTHORIZATION_PLANNING_REQUEST: 'EDIT_AUTHORIZATION_PLANNING_REQUEST',
  EDIT_AUTHORIZATION_PLANNING_SUCCESS: 'EDIT_AUTHORIZATION_PLANNING_SUCCESS',
  EDIT_AUTHORIZATION_PLANNING_FAILURE: 'EDIT_AUTHORIZATION_PLANNING_FAILURE',
  EDIT_AUTHORIZATION_PLANNING_LOADER: 'EDIT_AUTHORIZATION_PLANNING_LOADER',
  EDIT_AUTHORIZATION_PLANNING_RESET: 'EDIT_AUTHORIZATION_PLANNING_RESET',
  UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_REQUEST: 'UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_REQUEST',
  UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_SUCCESS: 'UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_SUCCESS',
  UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_FAILURE: 'UPDATE_THERAPY_PLANNING_DISCHARGE_DATE_FAILURE',
  RESET_THERAPY_PLANNING_DISCHARGE_DATE_REQUEST: 'RESET_THERAPY_PLANNING_DISCHARGE_DATE_REQUEST',

  //get authorization details

  GET_AUTHORIZATION_DETAILS_REQUEST: 'GET_AUTHORIZATION_DETAILS_REQUEST',
  GET_AUTHORIZATION_DETAILS_SUCCESS: 'GET_AUTHORIZATION_DETAILS_SUCCESS',
  GET_AUTHORIZATION_DETAILS_FAILURE: 'GET_AUTHORIZATION_DETAILS_FAILURE',
  GET_AUTHORIZATION_DETAILS_LOADER: 'GET_AUTHORIZATION_DETAILS_LOADER',
  GET_AUTHORIZATION_DETAILS_RESET: 'GET_AUTHORIZATION_DETAILS_RESET',

  GET_CASE_MIX_GROUP_REQUEST: 'GET_CASE_MIX_GROUP_REQUEST',
  GET_CASE_MIX_GROUP_SUCCESS: 'GET_CASE_MIX_GROUP_SUCCESS',
  GET_CASE_MIX_GROUP_FAILURE: 'GET_CASE_MIX_GROUP_FAILURE',
  GET_CASE_MIX_GROUP_LOADING: 'GET_CASE_MIX_GROUP_LOADING',

  //get multiple MdS assessment
  GET_MULTIPLE_MDS_ASSESSMENT_SUCCESS: 'GET_MULTIPLE_MDS_ASSESSMENT_SUCCESS',
  GET_MULTIPLE_MDS_ASSESSMENT_FAILURE: 'GET_MULTIPLE_MDS_ASSESSMENT_FAILURE',
  GET_MULTIPLE_MDS_ASSESSMENT_LOADING: 'GET_MULTIPLE_MDS_ASSESSMENT_LOADING',
  GET_MULTIPLE_MDS_ASSESSMENT_REQUEST: 'GET_MULTIPLE_MDS_ASSESSMENT_REQUEST',
  GET_MULTIPLE_MDS_ASSESSMENT_RESET: 'GET_MULTIPLE_MDS_ASSESSMENT_RESET',

  //mds assessment csv upload
  REQUEST_VALIDATE_MDS_CSV_TEMPLATE: 'REQUEST_VALIDATE_MDS_CSV_TEMPLATE',
  SUCCESS_VALIDATE_MDS_CSV_TEMPLATE: 'SUCCESS_VALIDATE_MDS_CSV_TEMPLATE',
  FAILURE_VALIDATE_MDS_CSV_TEMPLATE: 'FAILURE_VALIDATE_MDS_CSV_TEMPLATE',
  LOADING_VALIDATE_MDS_CSV_TEMPLATE: 'LOADING_VALIDATE_MDS_CSV_TEMPLATE',
  RESET_VALIDATE_MDS_CSV_TEMPLATE: 'RESET_VALIDATE_MDS_CSV_TEMPLATE',

  //mds csv template
  REQUEST_UPLOAD_MDS_CSV_TEMPLATE: 'REQUEST_UPLOAD_MDS_CSV_TEMPLATE',
  SUCCESS_UPLOAD_MDS_CSV_TEMPLATE: 'SUCCESS_UPLOAD_MDS_CSV_TEMPLATE',
  FAILURE_UPLOAD_MDS_CSV_TEMPLATE: 'FAILURE_UPLOAD_MDS_CSV_TEMPLATE',
  RESET_UPLOAD_MDS_CSV_TEMPLATE: 'RESET_UPLOAD_MDS_CSV_TEMPLATE',
  LOADING_UPLOAD_MDS_CSV_TEMPLATE: 'LOADING_UPLOAD_MDS_CSV_TEMPLATE',

  //therapy planning 2.0
  GET_PATIENT_THERAPY_PLANNING_REQUEST_2_0: 'GET_PATIENT_THERAPY_PLANNING_REQUEST_2_0',
  GET_PATIENT_THERAPY_PLANNING_SUCCESS_2_0: 'GET_PATIENT_THERAPY_PLANNING_SUCCESS_2_0',
  GET_PATIENT_THERAPY_PLANNING_FAILURE_2_0: 'GET_PATIENT_THERAPY_PLANNING_FAILURE_2_0',
  GET_PATIENT_THERAPY_PLANNING_LOADING_2_0: 'GET_PATIENT_THERAPY_PLANNING_LOADING_2_0',
  GET_PATIENT_THERAPY_PLANNING_RESET_2_0: 'GET_PATIENT_THERAPY_PLANNING_RESET_2_0',

  //get therapy planning 2.0
  GET_DATA_THERAPY_PLANNING_REQUEST_2_0: 'GET_DATA_THERAPY_PLANNING_REQUEST_2_0',
  GET_DATA_THERAPY_PLANNING_SUCCESS_2_0: 'GET_DATA_THERAPY_PLANNING_SUCCESS_2_0',
  GET_DATA_THERAPY_PLANNING_FAILURE_2_0: 'GET_DATA_THERAPY_PLANNING_FAILURE_2_0',
  GET_DATA_THERAPY_PLANNING_LOADING_2_0: 'GET_DATA_THERAPY_PLANNING_LOADING_2_0',
  GET_DATA_THERAPY_PLANNING_RESET_2_0: 'GET_DATA_THERAPY_PLANNING_RESET_2_0',
  ADD_SINGLE_THERAPY_PLANNING_2_0: 'ADD_SINGLE_THERAPY_PLANNING_2_0',

  //get therapy planning summary
  GET_THERAPY_PLANNING_SUMMARY_SUCCESS_2_0: 'GET_THERAPY_PLANNING_SUMMARY_SUCCESS_2_0',
  GET_THERAPY_PLANNING_SUMMARY_REQUEST_2_0: 'GET_THERAPY_PLANNING_SUMMARY_REQUEST_2_0',
  GET_THERAPY_PLANNING_SUMMARY_FAILURE_2_0: 'GET_THERAPY_PLANNING_SUMMARY_FAILURE_2_0',
  GET_THERAPY_PLANNING_SUMMARY_LOADING_2_0: 'GET_THERAPY_PLANNING_SUMMARY_LOADING_2_0',
  GET_THERAPY_PLANNING_SUMMARY_RESET_2_0: 'GET_THERAPY_PLANNING_SUMMARY_RESET_2_0',

  //edit single cell
  EDIT_SINGLE_CELL_THERAPY_PLANNING_REQUEST: 'EDIT_SINGLE_CELL_THERAPY_PLANNING_REQUEST',
  EDIT_SINGLE_CELL_THERAPY_PLANNING_SUCCESS: 'EDIT_SINGLE_CELL_THERAPY_PLANNING_SUCCESS',
  EDIT_SINGLE_CELL_THERAPY_PLANNING_FAILURE: 'EDIT_SINGLE_CELL_THERAPY_PLANNING_FAILURE',
  EDIT_SINGLE_CELL_THERAPY_PLANNING_RESET: 'EDIT_SINGLE_CELL_THERAPY_PLANNING_RESET',
  EDIT_SINGLE_CELL_THERAPY_PLANNING_LOADING: 'EDIT_SINGLE_CELL_THERAPY_PLANNING_LOADING',

  //update uncovered day

  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_SUCCESS: 'UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_SUCCESS',
  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_FAILURE: 'UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_FAILURE',
  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_REQUEST: 'UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_REQUEST',
  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_RESET: 'UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_RESET',
  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_LOADING: 'UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_LOADING',

  //get therapy planning 2.0 discharge date
  GET_THERAPY_PLANNING_DISCHARGE_SUCCESS_2_0: 'GET_THERAPY_PLANNING_DISCHARGE_SUCCESS_2_0',
  GET_THERAPY_PLANNING_DISCHARGE_FAILURE_2_0: 'GET_THERAPY_PLANNING_DISCHARGE_FAILURE_2_0',
  GET_THERAPY_PLANNING_DISCHARGE_REQUEST_2_0: 'GET_THERAPY_PLANNING_DISCHARGE_REQUEST_2_0',
  GET_THERAPY_PLANNING_DISCHARGE_RESET_2_0: 'GET_THERAPY_PLANNING_DISCHARGE_RESET_2_0',
  GET_THERAPY_PLANNING_DISCHARGE_LOADING_2_0: 'GET_THERAPY_PLANNING_DISCHARGE_LOADING_2_0',

  //copy paste 2.0
  COPY_PASTE_THERAPY_PLANNING_LOADING_2_0: 'COPY_PASTE_THERAPY_PLANNING_LOADING_2_0',
  COPY_PASTE_THERAPY_PLANNING_REQUEST_2_0: 'COPY_PASTE_THERAPY_PLANNING_REQUEST_2_0',
  COPY_PASTE_THERAPY_PLANNING_SUCCESS_2_0: 'COPY_PASTE_THERAPY_PLANNING_SUCCESS_2_0',
  COPY_PASTE_THERAPY_PLANNING_FAILURE_2_0: 'COPY_PASTE_THERAPY_PLANNING_FAILURE_2_0',
  COPY_PASTE_THERAPY_PLANNING_RESET_2_0: 'COPY_PASTE_THERAPY_PLANNING_RESET_2_0',

  //save therapy templates
  APPLY_THERAPY_TEMPLATES_REQUEST_2_0: 'APPLY_THERAPY_TEMPLATES_REQUEST_2_0',
  APPLY_THERAPY_TEMPLATES_SUCCESS_2_0: 'APPLY_THERAPY_TEMPLATES_SUCCESS_2_0',
  APPLY_THERAPY_TEMPLATES_FAILURE_2_0: 'APPLY_THERAPY_TEMPLATES_FAILURE_2_0',
  APPLY_THERAPY_TEMPLATES_LOADING_2_0: 'APPLY_THERAPY_TEMPLATES_LOADING_2_0',
  APPLY_THERAPY_TEMPLATES_RESET_2_0: 'APPLY_THERAPY_TEMPLATES_RESET_2_0',

  //get all templates
  GET_ALL_THERAPY_TEMPLATES_SUCCESS_2_0: 'GET_ALL_THERAPY_TEMPLATES_SUCCESS_2_0',
  GET_ALL_THERAPY_TEMPLATES_FAILURE_2_0: 'GET_ALL_THERAPY_TEMPLATES_FAILURE_2_0',
  GET_ALL_THERAPY_TEMPLATES_LOADING_2_0: 'GET_ALL_THERAPY_TEMPLATES_LOADING_2_0',
  GET_ALL_THERAPY_TEMPLATES_RESET_2_0: 'GET_ALL_THERAPY_TEMPLATES_RESET_2_0',
  GET_ALL_THERAPY_TEMPLATES_REQUEST_2_0: 'GET_ALL_THERAPY_TEMPLATES_REQUEST_2_0',

  //apply selected templates
  APPLY_SELECTED_TEMPLATES_REQUEST_2_0: 'APPLY_SELECTED_TEMPLATES_REQUEST',
  APPLY_SELECTED_TEMPLATES_SUCCESS_2_0: 'APPLY_SELECTED_TEMPLATES_SUCCESS',
  APPLY_SELECTED_TEMPLATES_FAILURE_2_0: 'APPLY_SELECTED_TEMPLATES_FAILURE',
  APPLY_SELECTED_TEMPLATES_LOADING_2_0: 'APPLY_SELECTED_TEMPLATES_LOADING',
  APPLY_SELECTED_TEMPLATES_RESET_2_0: 'APPLY_SELECTED_TEMPLATES_RESET',

  // get MDS ASSESSMENT therapy planning range

  GET_MDS_ASSESSMENT_RANGE_REQUEST: 'GET_MDS_ASSESSMENT_RANGE_REQUEST',
  GET_MDS_ASSESSMENT_RANGE_SUCCESS: 'GET_MDS_ASSESSMENT_RANGE_SUCCESS',
  GET_MDS_ASSESSMENT_RANGE_FAILURE: 'GET_MDS_ASSESSMENT_RANGE_FAILURE',
  GET_MDS_ASSESSMENT_RANGE_LOADING: 'GET_MDS_ASSESSMENT_RANGE_LOADING',
  GET_MDS_ASSESSMENT_RANGE_RESET: 'GET_MDS_ASSESSMENT_RANGE_RESET',

  //get single mds assessment
  GET_SINGLE_MDS_ASSESSMENT_REQUEST: 'GET_SINGLE_MDS_ASSESSMENT_REQUEST',
  GET_SINGLE_MDS_ASSESSMENT_SUCCESS: 'GET_SINGLE_MDS_ASSESSMENT_SUCCESS',
  GET_SINGLE_MDS_ASSESSMENT_FAILURE: 'GET_SINGLE_MDS_ASSESSMENT_FAILURE',
  GET_SINGLE_MDS_ASSESSMENT_LOADING: 'GET_SINGLE_MDS_ASSESSMENT_LOADING',
  GET_SINGLE_MDS_ASSESSMENT_RESET: 'GET_SINGLE_MDS_ASSESSMENT_RESET',

  //delete mds assessment by date

  DELETE_MDS_ASSESSMENT_BY_DATE_REQUEST: 'DELETE_MDS_ASSESSMENT_BY_DATE_REQUEST',
  DELETE_MDS_ASSESSMENT_BY_DATE_SUCCESS: 'DELETE_MDS_ASSESSMENT_BY_DATE_SUCCESS',
  DELETE_MDS_ASSESSMENT_BY_DATE_FAILURE: 'DELETE_MDS_ASSESSMENT_BY_DATE_FAILURE',
  DELETE_MDS_ASSESSMENT_BY_DATE_RESET: 'DELETE_MDS_ASSESSMENT_BY_DATE_RESET',
  DELETE_MDS_ASSESSMENT_BY_DATE_LOADING: 'DELETE_MDS_ASSESSMENT_BY_DATE_LOADING',

  //delete single mds assessment

  DELETE_SINGLE_MDS_ASSESSMENT_BY_REQUEST: 'DELETE_SINGLE_MDS_ASSESSMENT_BY_REQUEST',
  DELETE_SINGLE_MDS_ASSESSMENT_BY_SUCCESS: 'DELETE_SINGLE_MDS_ASSESSMENT_BY_SUCCESS',
  DELETE_SINGLE_MDS_ASSESSMENT_BY_FAILURE: 'DELETE_SINGLE_MDS_ASSESSMENT_BY_FAILURE',
  DELETE_SINGLE_MDS_ASSESSMENT_BY_RESET: 'DELETE_SINGLE_MDS_ASSESSMENT_BY_RESET',
  DELETE_SINGLE_MDS_ASSESSMENT_BY_LOADING: 'DELETE_SINGLE_MDS_ASSESSMENT_BY_LOADING',

  // get 7 day look back data
  GET_7DAY_LOOK_BACK_SUM_REQUEST: 'GET_7DAY_LOOK_BACK_SUM_REQUEST',
  GET_7DAY_LOOK_BACK_SUM_SUCCESS: 'GET_7DAY_LOOK_BACK_SUM_SUCCESS',
  GET_7DAY_LOOK_BACK_SUM_FAILURE: 'GET_7DAY_LOOK_BACK_SUM_FAILURE',
  GET_7DAY_LOOK_BACK_SUM_RESET: 'GET_7DAY_LOOK_BACK_SUM_RESET',
  GET_7DAY_LOOK_BACK_SUM_LOADING: 'GET_7DAY_LOOK_BACK_SUM_LOADING',
};

export const newTherapyTemplateAction = {
  //create new therapy template
  CREATE_NEW_THERAPY_TEMPLATE_REQUEST: 'CREATE_NEW_THERAPY_TEMPLATE_REQUEST',
  CREATE_NEW_THERAPY_TEMPLATE_LOADING: 'CREATE_NEW_THERAPY_TEMPLATE_LOADING',
  CREATE_NEW_THERAPY_TEMPLATE_SUCCESS: 'CREATE_NEW_THERAPY_TEMPLATE_SUCCESS',
  CREATE_NEW_THERAPY_TEMPLATE_FAILURE: 'CREATE_NEW_THERAPY_TEMPLATE_FAILURE',
  CREATE_NEW_THERAPY_TEMPLATE_RESET: 'CREATE_NEW_THERAPY_TEMPLATE_RESET',

  DELETE_THERAPY_TEMPLATE_REQUEST: 'DELETE_THERAPY_TEMPLATE_REQUEST',
  DELETE_THERAPY_TEMPLATE_LOADING: 'DELETE_THERAPY_TEMPLATE_LOADING',
  DELETE_THERAPY_TEMPLATE_SUCCESS: 'DELETE_THERAPY_TEMPLATE_SUCCESS',
  DELETE_THERAPY_TEMPLATE_FAILURE: 'DELETE_THERAPY_TEMPLATE_FAILURE',
  DELETE_THERAPY_TEMPLATE_RESET: 'DELETE_THERAPY_TEMPLATE_RESET',

  EDIT_THERAPY_TEMPLATE_REQUEST: 'EDIT_THERAPY_TEMPLATE_REQUEST',
  EDIT_THERAPY_TEMPLATE_LOADING: 'EDIT_THERAPY_TEMPLATE_LOADING',
  EDIT_THERAPY_TEMPLATE_SUCCESS: 'EDIT_THERAPY_TEMPLATE_SUCCESS',
  EDIT_THERAPY_TEMPLATE_FAILURE: 'EDIT_THERAPY_TEMPLATE_FAILURE',
  EDIT_THERAPY_TEMPLATE_RESET: '  EDIT_THERAPY_TEMPLATE_RESET',
};

export const TherapistAction = {
  THERAPIST_PROFILE_REQUEST: 'THERAPIST_PROFILE_REQUEST',
  THERAPIST_PROFILE_SUCCESS: 'THERAPIST_PROFILE_SUCCESS',
  THERAPIST_PROFILE_FAILURE: 'THERAPIST_PROFILE_FAILURE',
  GET_ALL_THERAPIST_TASK_REQUEST: 'GET_ALL_THERAPIST_TASK_REQUEST',
  GET_ALL_THERAPIST_TASK_SUCCESS: 'GET_ALL_THERAPIST_TASK_SUCCESS',
  GET_ALL_THERAPIST_TASK_FAILURE: 'GET_ALL_THERAPIST_TASK_FAILURE',
  GET_ALL_TASK_TYPE_REQUEST: 'GET_ALL_TASK_TYPE_REQUEST',
  GET_ALL_TASK_TYPE_SUCCESS: 'GET_ALL_TASK_TYPE_SUCCESS',
  GET_ALL_TASK_TYPE_FAILURE: 'GET_ALL_TASK_TYPE_FAILURE',
  GET_ALL_THERAPIST_LIST_TYPE_REQUEST: 'GET_ALL_THERAPIST_LIST_TYPE_REQUEST',
  GET_ALL_THERAPIST_LIST_TYPE_SUCCESS: 'GET_ALL_THERAPIST_LIST_TYPE_SUCCESS',
  GET_ALL_THERAPIST_LIST_TYPE_FAILURE: 'GET_ALL_THERAPIST_LIST_TYPE_FAILURE',
  GET_ALL_THERAPIST_LIST_TYPE_RESET: 'GET_ALL_THERAPIST_LIST_TYPE_RESET',
  GET_ALL_THERAPIST_DICIPLINE_TYPE_REQUEST: 'GET_ALL_THERAPIST_DICIPLINE_TYPE_REQUEST',
  GET_ALL_THERAPIST_DICIPLINE_TYPE_SUCCESS: 'GET_ALL_THERAPIST_DICIPLINE_TYPE_SUCCESS',
  GET_ALL_THERAPIST_DICIPLINE_TYPE_FAILURE: 'GET_ALL_THERAPIST_DICIPLINE_TYPE_FAILURE',

  THERAPIST_TASK_MIGRATE_REQUEST: 'THERAPIST_TASK_MIGRATE_REQUEST',
  THERAPIST_TASK_MIGRATE_RESET: 'THERAPIST_TASK_MIGRATE_RESET',
  THERAPIST_TASK_MIGRATE_SUCCESS: 'THERAPIST_TASK_MIGRATE_SUCCESS',
  THERAPIST_TASK_MIGRATE_FAILURE: 'THERAPIST_TASK_MIGRATE_FAILURE',

  MIGRATE_THERAPIST_PATIENT_REQUEST: 'MIGRATE_THERAPIST_PATIENT_REQUEST',
  MIGRATE_THERAPIST_PATIENT_RESET: 'MIGRATE_THERAPIST_PATIENT_RESET',
  MIGRATE_THERAPIST_PATIENT_SUCCESS: 'MIGRATE_THERAPIST_PATIENT_SUCCESS',
  MIGRATE_THERAPIST_PATIENT_FAILURE: 'MIGRATE_THERAPIST_PATIENT_FAILURE',

  THERAPIST_TASK_ASSIGN_REQUEST: 'THERAPIST_TASK_ASSIGN_REQUEST',
  THERAPIST_TASK_ASSIGN_RESET: 'THERAPIST_TASK_ASSIGN_RESET',
  THERAPIST_TASK_ASSIGN_SUCCESS: 'THERAPIST_TASK_ASSIGN_SUCCESS',
  THERAPIST_TASK_ASSIGN_FAILURE: 'THERAPIST_TASK_ASSIGN_FAILURE',
  THERAPIST_TASK_ASSIGN_UNDO_REQUEST: 'THERAPIST_TASK_ASSIGN_UNDO_REQUEST',
  THERAPIST_TASK_ASSIGN_UNDO_SUCCESS: 'THERAPIST_TASK_ASSIGN_UNDO_SUCCESS',
  THERAPIST_TASK_ASSIGN_UNDO_RESET: 'THERAPIST_TASK_ASSIGN_UNDO_RESET',
  THERAPIST_TASK_ASSIGN_UNDO_FAILURE: 'THERAPIST_TASK_ASSIGN_UNDO_FAILURE',
  THERAPIST_REARRANGE_TASK_REQUEST: 'THERAPIST_REARRANGE_TASK_REQUEST',
  THERAPIST_REARRANGE_TASK_SUCCESS: 'THERAPIST_REARRANGE_TASK_SUCCESS',
  THERAPIST_REARRANGE_TASK_FAILURE: 'THERAPIST_REARRANGE_TASK_FAILURE',
  EDIT_TASK_REQUEST: 'EDIT_TASK_REQUEST',
  EDIT_TASK_RESET: 'EDIT_TASK_RESET',
  EDIT_TASK_SUCCESS: 'EDIT_TASK_SUCCESS',
  EDIT_TASK_FAILURE: 'EDIT_TASK_FAILURE',
  THERAPIST_DIALOG_ASSIGN_TASK_REQUEST: 'THERAPIST_DIALOG_ASSIGN_TASK_REQUEST',
  THERAPIST_DIALOG_ASSIGN_TASK_RESET: 'THERAPIST_DIALOG_ASSIGN_TASK_RESET',
  THERAPIST_DIALOG_ASSIGN_TASK_SUCCESS: 'THERAPIST_DIALOG_ASSIGN_TASK_SUCCESS',
  THERAPIST_DIALOG_ASSIGN_TASK_FAILURE: 'THERAPIST_DIALOG_ASSIGN_TASK_FAILURE',
  REQUEST_GET_ALL_THERAPIST: 'REQUEST_GET_ALL_THERAPIST',
  SUCCESS_GET_ALL_THERAPIST: 'SUCCESS_GET_ALL_THERAPIST',
  FAILURE_GET_ALL_THERAPIST: 'FAILURE_GET_ALL_THERAPIST',
  LOADING_GET_ALL_THERAPIST: 'LOADING_GET_ALL_THERAPIST',
  THERAPIST_PROFILE_RESET: 'THERAPIST_PROFILE_RESET',
  PRE_THERAPIST_PROFILE_REQUEST: 'PRE_THERAPIST_PROFILE_REQUEST',
  PRE_THERAPIST_PROFILE_SUCCESS: 'PRE_THERAPIST_PROFILE_SUCCESS',
  PRE_THERAPIST_PROFILE_FAILURE: 'PRE_THERAPIST_PROFILE_FAILURE',

  THERAPIST_PATIENT_UNASSIGN_REQUEST: 'THERAPIST_PATIENT_UNASSIGN_REQUEST',
  THERAPIST_PATIENT_UNASSIGN_SUCCESS: 'THERAPIST_PATIENT_UNASSIGN_SUCCESS',
  THERAPIST_PATIENT_UNASSIGN_RESET: 'THERAPIST_PATIENT_UNASSIGN_RESET',
  THERAPIST_PATIENT_UNASSIGN_FAILURE: 'THERAPIST_PATIENT_UNASSIGN_FAILURE',

  // AutoMatching
  THERAPIST_AUTO_MATCHING_REQUEST: 'THERAPIST_AUTO_MATCHING_REQUEST',
  THERAPIST_AUTO_MATCHING_SUCCESS: 'THERAPIST_AUTO_MATCHING_SUCCESS',
  THERAPIST_AUTO_MATCHING_FAILURE: 'THERAPIST_AUTO_MATCHING_FAILURE',
  THERAPIST_AUTO_MATCHING_LOADING: 'THERAPIST_AUTO_MATCHING_LOADING',
  THERAPIST_AUTO_MATCHING_RESET: 'THERAPIST_AUTO_MATCHING_RESET',
  THERAPIST_DEFUALT_THERAPIST_REQUEST: 'THERAPIST_DEFAULT_THERAPIST_REQUEST',
  THERAPIST_DEFAULT_THERAPIST_SUCCESS: 'THERAPIST_DEFAULT_THERAPIST_SUCCESS',
  THERAPIST_DEFAULT_THERAPIST_FAILURE: 'THERAPIST_DEFAULT_THERAPIST_FAILURE',
  THERAPIST_DEFAULT_THERAPIST_RESET: 'THERAPIST_AUTO_MATCHING_RESET',
  DISABLE_AUTO_MATCH_REQUEST: 'DISABLE_AUTO_MATCH_REQUEST',
  DISABLE_AUTO_MATCH_SUCCESS: 'DISABLE_AUTO_MATCH_SUCCESS',
  DISABLE_AUTO_MATCH_FAILURE: 'DISABLE_AUTO_MATCH_FAILURE',

  //paycome
  GET_PAYCOME_PROVIDER_REQUEST: 'GET_PAYCOME_PROVIDER_REQUEST',
  GET_PAYCOME_PROVIDER_SUCCESS: 'GET_PAYCOME_PROVIDER_SUCCESS',
  GET_PAYCOME_PROVIDER_FAILURE: 'GET_PAYCOME_PROVIDER_FAILURE',
  GET_PAYCOME_PROVIDER_LOADER: 'GET_PAYCOME_PROVIDER_LOADER',
  GET_PAYCOME_PROVIDER_RESET: 'GET_PAYCOME_PROVIDER_RESET',
  REQUEST_GET_THERAPISTS_BY_ROLE: 'REQUEST_GET_THERAPISTS_BY_ROLE',
  SUCCESS_GET_THERAPISTS_BY_ROLE: 'SUCCESS_GET_THERAPISTS_BY_ROLE',
  FAILURE_GET_THERAPISTS_BY_ROLE: 'FAILURE_GET_THERAPISTS_BY_ROLE',

  // setting common duration to G&C tasks
  SET_COMMON_DURATION_FOR_GC_REQUEST: 'SET_COMMON_DURATION_FOR_GC_REQUEST',
  SET_COMMON_DURATION_FOR_GC_SUCCESS: 'SET_COMMON_DURATION_FOR_GC_SUCCESS',
  SET_COMMON_DURATION_FOR_GC_FAILURE: 'SET_COMMON_DURATION_FOR_GC_FAILURE',
  SET_COMMON_DURATION_FOR_GC_RESET:'SET_COMMON_DURATION_FOR_GC_RESET'
};

export const schedularTherapistFilterAction = {
  SET_THERAPIST_FILTER_IN_SCHUDLAR: 'SET_THERAPIST_FILTER_IN_SCHUDLAR',
  RESET_THERAPIST_FILTER_IN_SCHUDLAR: 'RESET_THERAPIST_FILTER_IN_SCHUDLAR',
  GET_ALL_FILTERED_THERAPIST_REQUEST: 'GET_ALL_FILTERED_THERAPIST_REQUEST',

  GET_ALL_MAINTAINED_THERAPISTS_REQUEST: 'GET_ALL_MAINTAINED_THERAPISTS_REQUEST',
  GET_ALL_MAINTAINED_THERAPISTS_SUCCESS: 'GET_ALL_MAINTAINED_THERAPISTS_SUCCESS',
  GET_ALL_MAINTAINED_THERAPISTS_FAILURE: 'GET_ALL_MAINTAINED_THERAPISTS_FAILURE',
  GET_ALL_MAINTAINED_THERAPISTS_RESET: 'GET_ALL_MAINTAINED_THERAPISTS_RESET',

  MAINTAIN_THERAPIST_FILTER_REQUEST: 'MAINTAIN_THERAPIST_FILTER_REQUEST',
  MAINTAIN_THERAPIST_FILTER_SUCCESS: 'MAINTAIN_THERAPIST_FILTER_SUCCESS',
  MAINTAIN_THERAPIST_FILTER_FAILURE: 'MAINTAIN_THERAPIST_FILTER_FAILURE',
  // MAINTAIN_THERAPIST_FILTER_RESET: 'MAINTAIN_THERAPIST_FILTER_RESET',
};

export const schedularAnnouncementActions = {
  GET_ALL_ANNOUNCEMENTS_REQUEST: 'GET_ALL_ANNOUNCEMENTS_REQUEST',
  GET_ALL_ANNOUNCEMENTS_LOADING: 'GET_ALL_ANNOUNCEMENTS_LOADING',
  GET_ALL_ANNOUNCEMENTS_SUCCESS: 'GET_ALL_ANNOUNCEMENTS_SUCCESS',
  GET_ALL_ANNOUNCEMENTS_FAILURE: 'GET_ALL_ANNOUNCEMENTS_FAILURE',
  GET_ALL_ANNOUNCEMENTS_RESET: 'GET_ALL_ANNOUNCEMENTS_RESET',

  CREATE_ANNOUNCEMENT_REQUEST: 'CREATE_ANNOUNCEMENT_REQUEST',
  CREATE_ANNOUNCEMENT_LOADING: 'CREATE_ANNOUNCEMENT_LOADING',
  CREATE_ANNOUNCEMENT_SUCCESS: 'CREATE_ANNOUNCEMENT_SUCCESS',
  CREATE_ANNOUNCEMENT_FAILURE: 'CREATE_ANNOUNCEMENT_FAILURE',
  CREATE_ANNOUNCEMENT_RESET: 'CREATE_ANNOUNCEMENT_RESET',

  UPDATE_ANNOUNCEMENT_REQUEST: 'UPDATE_ANNOUNCEMENT_REQUEST',
  UPDATE_ANNOUNCEMENT_LOADING: 'UPDATE_ANNOUNCEMENT_LOADING',
  UPDATE_ANNOUNCEMENT_SUCCESS: 'UPDATE_ANNOUNCEMENT_SUCCESS',
  UPDATE_ANNOUNCEMENT_FAILURE: 'UPDATE_ANNOUNCEMENT_FAILURE',
  UPDATE_ANNOUNCEMENT_RESET: 'UPDATE_ANNOUNCEMENT_RESET',

  DELETE_ANNOUNCEMENT_REQUEST: 'DELETE_ANNOUNCEMENT_REQUEST',
  DELETE_ANNOUNCEMENT_SUCCESS: 'DELETE_ANNOUNCEMENT_SUCCESS',
  DELETE_ANNOUNCEMENT_FAILURE: 'DELETE_ANNOUNCEMENT_FAILURE',
  DELETE_ANNOUNCEMENT_RESET: 'DELETE_ANNOUNCEMENT_RESET',
};

export const selectedPatient = {
  SELECT_PATIENT_FOR_THERAPY: 'SELECT_PATIENT_FOR_THERAPY',
  SELECT_PATIENT_LIST_FOR_THERAPY: 'SELECT_PATIENT_LIST_FOR_THERAPY',
  RESET_PATIENT_FOR_THERAPY: 'RESET_PATIENT_FOR_THERAPY',
};

export const PatientActions = {
  GET_SINGLE_PATIENT_SUCCESS: 'GET_SINGLE_PATIENT_SUCCESS',
  GET_SINGLE_PATIENT_REQUEST: 'GET_SINGLE_PATIENT_REQUEST',
  GET_SINGLE_PATIENT_LOADING: 'GET_SINGLE_PATIENT_LOADING',
  GET_SINGLE_PATIENT_FAILURE: 'GET_SINGLE_PATIENT_FAILURE',

  REQUEST_CREATE_PATIENT: 'REQUEST_CREATE_PATIENT',
  SUCCESS_CREATE_PATIENT: 'SUCCESS_CREATE_PATIENT',
  FAILURE_CREATE_PATIENT: 'FAILURE_CREATE_PATIENT',
  LOADING_CREATE_PATIENT: 'LOADING_CREATE_PATIENT',
  RESET_CREATE_PATIENT: 'RESET_CREATE_PATIENT',
  REQUEST_EDIT_PATIENT: 'REQUEST_EDIT_PATIENT',
  SUCCESS_EDIT_PATIENT: 'SUCCESS_EDIT_PATIENT',
  FAILURE_EDIT_PATIENT: 'FAILURE_EDIT_PATIENT',
  LOADING_EDIT_PATIENT: 'LOADING_EDIT_PATIENT',
  RESET_EDIT_PATIENT: 'RESET_EDIT_PATIENT',
  REQUEST_DEACTIVATE_PATIENT: 'REQUEST_DEACTIVATE_PATIENT',
  SUCCESS_DEACTIVATE_PATIENT: 'SUCCESS_DEACTIVATE_PATIENT',
  LOADING_DEACTIVATE_PATIENT: 'LOADING_DEACTIVATE_PATIENT',
  FAILURE_DEACTIVATE_PATIENT: 'FAILURE_DEACTIVATE_PATIENT',
  RESET_DEACTIVATE_PATIENT: 'RESET_DEACTIVATE_PATIENT',
  REQUEST_PATIENT_ID: 'REQUEST_PATIENT_ID',
  SUCCESS_PATIENT_ID: 'SUCCESS_PATIENT_ID',
  FAILURE_PATIENT_ID: 'FAILURE_PATIENT_ID',
  GET_REQUEST_ENTERPRISE_PHYSICIAN: 'GET_REQUEST_ENTERPRISE_PHYSICIAN',
  GET_SUCCESS_ENTERPRISE_PHYSICIAN: 'GET_SUCCESS_ENTERPRISE_PHYSICIAN',
  GET_FAILURE_ENTERPRISE_PHYSICIAN: 'GET_FAILURE_ENTERPRISE_PHYSICIAN',
  GET_FAILURE_ENTERPRISE_LOADER: 'GET_FAILURE_ENTERPRISE_LOADER',

  GET_PAYER_PLAN_TYPE_REQUEST: 'GET_PAYER_PLAN_TYPE_REQUEST',
  GET_PAYER_PLAN_TYPE_SUCCESS: 'GET_PAYER_PLAN_TYPE_SUCCESS',
  GET_PAYER_PLAN_TYPE_FAILURE: 'GET_PAYER_PLAN_TYPE_FAILURE',

  REQUEST_PATIENT_IN_ACTIVE_COUNT: 'REQUEST_PATIENT_IN_ACTIVE_COUNT',
  SUCCESS_PATIENT_IN_ACTIVE_COUNT: 'SUCCESS_PATIENT_IN_ACTIVE_COUNT',
  FAILURE_PATIENT_IN_ACTIVE_COUNT: 'FAILURE_PATIENT_IN_ACTIVE_COUNT',
  SUCCESS_PATIENT_IN_ACTIVE_COUNT_LOADING: 'SUCCESS_PATIENT_IN_ACTIVE_COUNT_LOADING',
  SWITCH_THERAPIST_DISCIPLINE: 'SWITCH_THERAPIST_DISCIPLINE',
};

export const facilityAction = {
  GET_ASSIGNED_FACILITY_REQUEST: 'GET_ASSIGNED_FACILITY_REQUEST',
  GET_ASSIGNED_FACILITY_SUCCESS: 'GET_ASSIGNED_FACILITY_SUCCESS',
  GET_ASSIGNED_FACILITY_FAILURE: 'GET_ASSIGNED_FACILITY_FAILURE',
  SWITCH_FACILITY_REQUEST: 'SWITCH_FACILITY_REQUEST',
  SWITCH_FACILITY_SUCCESS: 'SWITCH_FACILITY_SUCCESS',
  SWITCH_FACILITY_FAILURE: 'SWITCH_FACILITY_FAILURE',
  SWITCH_FACILITY_LOADER: 'SWITCH_FACILITY_LOADER',
  SWITCH_FACILITY_RESET: 'SWITCH_FACILITY_RESET',
  STORE_FACILITY_UUID: 'STORE_FACILITY_UUID',
  PRE_GET_ASSIGNED_FACILITY_REQUEST: 'PRE_GET_ASSIGNED_FACILITY_REQUEST',
  PRE_GET_ASSIGNED_FACILITY_SUCCESS: 'PRE_GET_ASSIGNED_FACILITY_SUCCESS',
  PRE_GET_ASSIGNED_FACILITY_FAILURE: 'PRE_GET_ASSIGNED_FACILITY_FAILURE',
};

export const LOADER_ON = 'LOADER_ON';
export const LOADER_OFF = 'LOADER_OFF';

export const contract = {
  GET_CONTRACT_COUNT_REQUEST: 'GET_CONTRACT_COUNT_REQUEST',
  GET_CONTRACT_COUNT_SUCCESS: 'GET_CONTRACT_COUNT_SUCCESS',
  GET_CONTRACT_COUNT_FAILURE: 'GET_CONTRACT_COUNT_FAILURE',
};

export const patientAction = {
  GET_PATIENT_REQUEST: 'GET_PATIENT_REQUEST',
  GET_PATIENT_SUCCESS: 'GET_PATIENT_SUCCESS',
  GET_PATIENT_FAILURE: 'GET_PATIENT_FAILURE',
  GET_PATIENT_LOADING: 'GET_PATIENT_LOADING',

  //patient list

  GET_ALL_PATIENT_LIST_REQUEST: 'GET_ALL_PATIENT_LIST_REQUEST',
  GET_ALL_PATIENT_LIST_SUCCESS: 'GET_ALL_PATIENT_LIST_SUCCESS',
  GET_ALL_PATIENT_LIST_FAILURE: 'GET_ALL_PATIENT_LIST_FAILURE',
  GET_ALL_PATIENT_LIST_LOADING: 'GET_ALL_PATIENT_LIST_LOADING',
  GET_ALL_PATIENT_LIST_RESET: 'GET_ALL_PATIENT_LIST_RESET',
  PERSISTS_BACK_PATIENT: 'PERSISTS_BACK_PATIENT',
  PERSISTS_BACK_PATIENT_CRITERIA: 'PERSISTS_BACK_PATIENT_CRITERIA',

  REQUEST_CREATE_PATIENT: 'REQUEST_CREATE_PATIENT',
  SUCCESS_CREATE_PATIENT: 'SUCCESS_CREATE_PATIENT',
  FAILURE_CREATE_PATIENT: 'FAILURE_CREATE_PATIENT',
  RESET_CREATE_PATIENT: 'RESET_CREATE_PATIENT',
  GET_THERAPIST_DISCIPLINE_SUCCESS: 'GET_THERAPIST_DISCIPLINE_SUCCESS',
  GET_THERAPIST_DISCIPLINE_FAILURE: 'GET_THERAPIST_DISCIPLINE_FAILURE',
  GET_THERAPIST_DISCIPLINE_LOADING: 'GET_THERAPIST_DISCIPLINE_LOADING',
  GET_THERAPIST_DISCIPLINE_REQUEST: 'GET_THERAPIST_DISCIPLINE_REQUEST',

  GET_THERAPIST_SINGLE_DISCIPLINE_SUCCESS: 'GET_THERAPIST_SINGLE_DISCIPLINE_SUCCESS',
  GET_THERAPIST_SINGLE_DISCIPLINE_FAILURE: 'GET_THERAPIST_SINGLE_DISCIPLINE_FAILURE',
  GET_THERAPIST_SINGLE_DISCIPLINE_LOADING: 'GET_THERAPIST_SINGLE_DISCIPLINE_LOADING',
  GET_THERAPIST_SINGLE_DISCIPLINE_REQUEST: 'GET_THERAPIST_SINGLE_DISCIPLINE_REQUEST',

  PUT_TREATMENT_THERAPIST_SUCCESS: 'PUT_THEATMENT_THERAPIST_SUCCESS',
  PUT_TREATMENT_THERAPIST_FAILURE: 'PUT_TREATMENT_THERAPIST_FAILURE',
  PUT_TREATMENT_THERAPIST_RESET: 'PUT_TREATMENT_THERAPIST_RESET',
  PUT_TREATMENT_THERAPIST_REQUEST: 'GET_TREATMENT_THERAPIST_REQUEST',

  GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_REQUEST: 'GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_REQUEST',
  GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_SUCCESS: 'GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_SUCCESS',
  GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_FAILURE: 'GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_FAILURE',
  GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_LOADING: 'GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_LOADING',

  REQUEST_VALIDATE_CSV_TEMPLATE: 'REQUEST_VALIDATE_CSV_TEMPLATE',
  SUCCESS_VALIDATE_CSV_TEMPLATE: 'SUCCESS_VALIDATE_CSV_TEMPLATE',
  FAILURE_VALIDATE_CSV_TEMPLATE: 'FAILURE_VALIDATE_CSV_TEMPLATE',
  RESET_VALIDATE_CSV_TEMPLATE: 'RESET_VALIDATE_CSV_TEMPLATE',

  REQUEST_UPLOAD_CSV_TEMPLATE: 'REQUEST_UPLOAD_CSV_TEMPLATE',
  SUCCESS_UPLOAD_CSV_TEMPLATE: 'SUCCESS_UPLOAD_CSV_TEMPLATE',
  FAILURE_UPLOAD_CSV_TEMPLATE: 'FAILURE_UPLOAD_CSV_TEMPLATE',
  RESET_UPLOAD_CSV_TEMPLATE: 'RESET_UPLOAD_CSV_TEMPLATE',

  GET_RECENT_UPLOADED_HISTORY_REQUEST: 'GET_RECENT_UPLOADED_HISTORY_REQUEST',
  GET_RECENT_UPLOADED_HISTORY_SUCCESS: 'GET_RECENT_UPLOADED_HISTORY_SUCCESS',
  GET_RECENT_UPLOADED_HISTORY_FAILURE: 'GET_RECENT_UPLOADED_HISTORY_FAILURE',
  GET_RECENT_UPLOADED_HISTORY_LOADING: 'GET_RECENT_UPLOADED_HISTORY_LOADING',
  GET_RECENT_UPLOADED_HISTORY_RESET: 'GET_RECENT_UPLOADED_HISTORY_RESET',

  GET_PATIENT_EXPORT_TEMPLATE_REQUEST: 'GET_PATIENT_EXPORT_TEMPLATE_REQUEST',
  GET_PATIENT_EXPORT_TEMPLATE_SUCCESS: 'GET_PATIENT_EXPORT_TEMPLATE_SUCCESS',
  GET_PATIENT_EXPORT_TEMPLATE_FAILURE: 'GET_PATIENT_EXPORT_TEMPLATE_FAILURE',
  GET_PATIENT_EXPORT_TEMPLATE_LOADING: 'GET_PATIENT_EXPORT_TEMPLATE_LOADING',
  GET_PATIENT_EXPORT_TEMPLATE_RESET: 'GET_PATIENT_EXPORT_TEMPLATE_RESET',

  GET_ALL_PATIENT_REQUEST: 'GET_ALL_PATIENT_REQUEST',
  GET_ALL_PATIENT_SUCCESS: 'GET_ALL_PATIENT_SUCCESS',
  GET_ALL_PATIENT_FAILURE: 'GET_ALL_PATIENT_FAILURE',
};

export const facilityStayAction = {
  REQUEST_GET_ALL_FACILITIES_STAY: 'REQUEST_GET_ALL_FACILITIES_STAY',
  SUCCESS_GET_ALL_FACILITIES_STAY: 'SUCCESS_GET_ALL_FACILITIES_STAY',
  LOADER_GET_ALL_FACILITIES_STAY: 'LOADER_GET_ALL_FACILITIES_STAY',
  FAILURE_GET_ALL_FACILITIES_STAY: 'FAILURE_GET_ALL_FACILITIES_STAY',
  REQUEST_UPDATE_FACILITY_STAY: 'REQUEST_UPDATE_FACILITY_STAY',
  SUCCESS_UPDATE_FACILITY_STAY: 'SUCCESS_UPDATE_FACILITY_STAY',
  FAILURE_UPDATE_FACILITY_STAY: 'FAILURE_UPDATE_FACILITY_STAY',
  RESET_UPDATE_FACILITY_STAY: 'RESET_UPDATE_FACILITY_STAY',
  REQUEST_CREATE_FACILITY_STAY: 'REQUEST_CREATE_FACILITY_STAY',
  SUCCESS_CREATE_FACILITY_STAY: 'SUCCESS_CREATE_FACILITY_STAY',
  FAILURE_CREATE_FACILITY_STAY: 'FAILURE_CREATE_FACILITY_STAY',
  RESET_CREATE_FACILITY_STAY: 'RESET_CREATE_FACILITY_STAY',
  UPDATE_FACILITY_LOADING: 'UPDATE_FACILITY_LOADING',
  CREATE_FACILITY_LOADING: 'CREATE_FACILITY_LOADING',

  REQUEST_GET_ALL_FACILITIES: 'REQUEST_GET_ALL_FACILITIES',
  SUCCESS_GET_ALL_FACILITIES: 'SUCCESS_GET_ALL_FACILITIES',
  FAILURE_GET_ALL_FACILITIES: 'FAILURE_GET_ALL_FACILITIES',
  RESET_GET_ALL_FACILITIES: 'RESET_GET_ALL_FACILITIES',
  CREATE_FACILITIES_LOADING: 'CREATE_FACILITIES_LOADING',

  GET_PATIENTS_REQUEST: 'GET_PATIENTS_REQUEST',
  GET_PATIENTS_SUCCESS: 'GET_PATIENTS_SUCCESS',
  GET_PATIENTS_FAILURE: 'GET_PATIENTS_FAILURE',
  GET_PATIENTS_LOADER: 'GET_PATIENTS_LOADER',
  GET_PATIENTS_RESET: 'GET_PATIENTS_RESET',
};

export const screeningAction = {
  GET_SCREENING_REQUEST: 'GET_SCREENING_REQUEST',
  GET_SCREENING_SUCCESS: 'GET_SCREENING_SUCCESS',
  GET_SCREENING_LOADER: 'GET_SCREENING_LOADER',
  GET_SCREENING_FAILURE: 'GET_SCREENING_FAILURE',
  PREVIEW_SCREENING: 'PREVIEW_SCREENING',
  CREATE_SCREENING_REQUEST: 'CREATE_SCREENING_REQUEST',
  CREATE_SCREENING_SUCCESS: 'CREATE_SCREENING_SUCCESS',
  CREATE_SCREENING_FAILURE: 'CREATE_SCREENING_FAILURE',
  RESET_CREATE_SCREENING: 'RESET_CREATE_SCREENING',
  EDIT_SCREENING_REQUEST: 'EDIT_SCREENING_REQUEST',
  EDIT_SCREENING_SUCCESS: 'EDIT_SCREENING_SUCCESS',
  EDIT_SCREENING_FAILURE: 'EDIT_SCREENING_FAILURE',
  RESET_EDIT_SCREENING: 'RESET_EDIT_SCREENING',
  GET_SCREENING_TYPE_REQUEST: 'GET_SCREENING_TYPE_REQUEST',
  GET_SCREENING_TYPE_SUCCESS: 'GET_SCREENING_TYPE_SUCCESS',
  GET_SCREENING_TYPE_FAILURE: 'GET_SCREENING_TYPE_FAILURE',
  GET_DISCIPLINE_TYPE_REQUEST: 'GET_DISCIPLINE_TYPE_REQUEST',
  GET_DISCIPLINE_TYPE_SUCCESS: 'GET_DISCIPLINE_TYPE_SUCCESS',
  GET_DISCIPLINE_TYPE_FAILURE: 'GET_DISCIPLINE_TYPE_FAILURE',
  GET_SINGLE_SCREENING_REQUEST: 'GET_SINGLE_SCREENING_REQUEST',
  GET_SINGLE_SCREENING_SUCCESS: 'GET_SINGLE_SCREENING_SUCCESS',
  GET_SINGLE_SCREENING_FAILURE: 'GET_SINGLE_SCREENING_FAILURE',

  //get Screening form id
  GET_FORM_ID_FOR_SCREENING_REQUEST: 'GET_FORM_ID_FOR_SCREENING_REQUEST',
  GET_FORM_ID_FOR_SCREENING_SUCCESS: 'GET_FORM_ID_FOR_SCREENING_SUCCESS',
  GET_FORM_ID_FOR_SCREENING_FAILURE: 'GET_FORM_ID_FOR_SCREENING_FAILURE',
  GET_FORM_ID_FOR_SCREENING_LOADER: 'GET_FORM_ID_FOR_SCREENING_LOADER',

  //post screening  submission form
  POST_SCREENING_SUBMISSION_SUCCESS: 'POST_SCREENING_SUBMISSION_SUCCESS',
  POST_SCREENING_SUBMISSION_FAILURE: 'POST_SCREENING_SUBMISSION_FAILURE',
  POST_SCREENING_SUBMISSION_LOADER: 'POST_SCREENING_SUBMISSION_LOADER',
  POST_SCREENING_SUBMISSION_REQUEST: 'POST_SCREENING_SUBMISSION_REQUEST',
  POST_SCREENING_SUBMISSION_RESET: 'POST_SCREENING_SUBMISSION_RESET',
};

export const departmentDashboard = {
  GET_DEPARTMENT_DASHBOARD_COUNT_REQUEST: 'GET_DEPARTMENT_DASHBOARD_COUNT_REQUEST',
  GET_DEPARTMENT_DASHBOARD_COUNT_SUCCESS: 'GET_DEPARTMENT_DASHBOARD_COUNT_SUCCESS',
  GET_DEPARTMENT_DASHBOARD_COUNT_FAILURE: 'GET_DEPARTMENT_DASHBOARD_COUNT_FAILURE',
  GET_DEPARTMENT_PTO_REQUEST: 'GET_DEPARTMENT_PTO_REQUEST',
  GET_DEPARTMENT_PTO_SUCCESS: 'GET_DEPARTMENT_PTO_SUCCESS',
  GET_DEPARTMENT_PTO_LOADING: 'GET_DEPARTMENT_PTO_LOADING',
  GET_DEPARTMENT_PTO_FAILURE: 'GET_DEPARTMENT_PTO_FAILURE',
  UPDATE_DEPARTMENT_PTO_REQUEST: 'UPDATE_DEPARTMENT_PTO_REQUEST',
  UPDATE_DEPARTMENT_PTO_SUCCESS: 'UPDATE_DEPARTMENT_PTO_SUCCESS',
  UPDATE_DEPARTMENT_PTO_LOADER: 'UPDATE_DEPARTMENT_PTO_LOADER',
  UPDATE_DEPARTMENT_PTO_FAILURE: 'UPDATE_DEPARTMENT_PTO_FAILURE',
  RESET_UPDATE_DEPARTMENT_PTO: 'RESET_UPDATE_DEPARTMENT_PTO',
  GET_DEPARTMENT_THERAPY_MIN_REQUEST: 'GET_DEPARTMENT_THERAPY_MIN_REQUEST',
  GET_DEPARTMENT_THERAPY_MIN_SUCCESS: 'GET_DEPARTMENT_THERAPY_MIN_SUCCESS',
  GET_DEPARTMENT_THERAPY_MIN_FAILURE: 'GET_DEPARTMENT_THERAPY_MIN_FAILURE',

  //check task of therapist
  CHECK_ASSIGN_TASK_PTO_REQUEST: 'CHECK_ASSIGN_TASK_PTO_REQUEST',
  CHECK_ASSIGN_TASK_PTO_SUCCESS: 'CHECK_ASSIGN_TASK_PTO_SUCCESS',
  CHECK_ASSIGN_TASK_PTO_FAILURE: 'CHECK_ASSIGN_TASK_PTO_FAILURE',
  CHECK_ASSIGN_TASK_PTO_LOADING: 'CHECK_ASSIGN_TASK_PTO_LOADING',
  CHECK_ASSIGN_TASK_PTO_RESET: 'CHECK_ASSIGN_TASK_PTO_RESET',
};

export const episodeOfCareAction = {
  GET_EPISODE_OF_CARE_REQUEST: 'GET_EPISODE_OF_CARE_REQUEST',
  GET_EPISODE_OF_CARE_SUCCESS: 'GET_EPISODE_OF_CARE_SUCCESS',
  GET_EPISODE_OF_CARE_FAILURE: 'GET_EPISODE_OF_CARE_FAILURE',
  ClOSE_EPISODE_OF_CARE_REQUEST: 'CLOSE_EPISODE_OF_CARE_REQUEST',
  CLOSE_EPISODE_OF_CARE_SUCCESS: 'CLOSE_EPISODE_OF_CARE_SUCCESS',
  CLOSE_EPISODE_OF_CARE_LOADING: 'CLOSE_EPISODE_OF_CARE_LOADING',
  CLOSE_EPISODE_OF_CARE_FAILURE: 'CLOSE_EPISODE_OF_CARE_FAILURE',
  RESET_CLOSE_EPISODE_OF_CARE: 'RESET_CLOSE_EPISODE_OF_CARE',
  GET_SINGLE_EPISODE_OF_CARE_REQUEST: 'GET_SINGLE_EPISODE_OF_CARE_REQUEST',
  GET_SINGLE_EPISODE_OF_CARE_SUCCESS: 'GET_GINGLE_EPISODE_OF_CARE_SUCCESS',
  GET_SINGLE_EPISODE_OF_CARE_FAILURE: 'GET_SINGLE_EPISODE_OF_CARE_FAILURE',
  CREATE_EPISODE_OF_CARE_REQUEST: 'CREATE_EPISODE_OF_CARE_REQUEST',
  CREATE_EPISODE_OF_CARE_SUCCESS: 'CREATE_EPISODE_OF_CARE_SUCCESS',
  CREATE_EPISODE_OF_CARE_FAILURE: 'CREATE_EPISODE_OF_CARE_FAILURE',
  CREATE_EPISODE_OF_CARE_LOADING: 'CREATE_EPISODE_OF_CARE_LOADING',
  RESET_CREATE_EPISODE_OF_CARE: 'RESET_CREATE_EPISODE_OF_CARE',
  EDIT_EPISODE_OF_CARE_REQUEST: 'EDIT_EPISODE_OF_CARE_REQUEST',
  EDIT_EPISODE_OF_CARE_SUCCESS: 'EDIT_EPISODE_OF_CARE_SUCCESS',
  EDIT_EPISODE_OF_CARE_FAILURE: 'EDIT_EPISODE_OF_CARE_FAILURE',
  RESET_EDIT_EPISODE_OF_CARE: 'RESET_EDIT_EPISODE_OF_CARE',
  GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_REQUEST: 'GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_REQUEST',
  GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_SUCCESS: 'GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_SUCCESS',
  GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_FAILURE: 'GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_FAILURE',
  GET_SINGLE_EPISODE_OF_CARE_LOADING: 'GET_SINGLE_EPISODE_OF_CARE_LOADING',
};

export const monthCloseOutAlertConstants = {
  GET_MONTH_CLOSE_OUT_ALERT_REQUEST: 'GET_MONTH_CLOSE_OUT_ALERT_REQUEST',
  GET_MONTH_CLOSE_OUT_ALERT_SUCCESS: 'GET_MONTH_CLOSE_OUT_ALERT_SUCCESS',
  GET_MONTH_CLOSE_OUT_ALERT_FAILURE: 'GET_MONTH_CLOSE_OUT_ALERT_FAILURE',
  GET_MONTH_CLOSE_OUT_ALERT_RESET: 'GET_MONTH_CLOSE_OUT_ALERT_RESET',
  GET_MONTH_CLOSE_OUT_ALERT_LOADING: 'GET_MONTH_CLOSE_OUT_ALERT_LOADING',

  //upload sign file
  UPLOAD_MONTH_END_ALERT_SIGN_REQUEST: 'UPLOAD_MONTH_END_ALERT_SIGN_REQUEST',
  UPLOAD_MONTH_END_ALERT_SIGN_SUCCESS: 'UPLOAD_MONTH_END_ALERT_SIGN_SUCCESS',
  UPLOAD_MONTH_END_ALERT_SIGN_FAILURE: 'UPLOAD_MONTH_END_ALERT_SIGN_FAILURE',
  UPLOAD_MONTH_END_ALERT_SIGN_LOADING: 'UPLOAD_MONTH_END_ALERT_SIGN_LOADING',
  UPLOAD_MONTH_END_ALERT_SIGN_RESET: 'UPLOAD_MONTH_END_ALERT_SIGN_RESET',
};

export const monthEndAlertConstants = {
  GET_MONTH_END_ALERTS_COUNT_REQUEST: 'GET_MONTH_END_ALERTS_COUNT_REQUEST',
  GET_MONTH_END_ALERTS_COUNT_SUCCESS: 'GET_MONTH_END_ALERTS_SUCCESS',
  GET_MONTH_END_ALERTS_COUNT_FAILURE: 'GET_MONTH_END_ALERTS_FAILURE',
  GET_CURRENT_MONTH_ALERT_COUNT_SUCCESS: 'GET_CURRENT_MONTH_ALERT_COUNT_SUCCESS',

  GET_THEME_COUNT_REQUEST: 'GET_THEME_COUNT_REQUEST',
  GET_THEME_COUNT_SUCCESS: 'GET_THEME_SUCCESS',
  GET_THEME_COUNT_FAILURE: 'GET_THEME_FAILURE',

  GET_OWNER_ALERT_COUNT_REQUEST: 'GET_OWNER_ALERT_COUNT_REQUEST',
  GET_OWNER_ALERT_COUNT_SUCCESS: 'GET_OWNER_ALERT_SUCCESS',
  GET_OWNER_ALERT_COUNT_FAILURE: 'GET_OWNER_ALERT_FAILURE',

  GET_LIST_OF_MONTH_REQUEST: 'GET_LIST_OF_MONTH_REQUEST',
  GET_LIST_OF_MONTH_SUCCESS: 'GET_LIST_OF_MONTH_SUCCESS',
  GET_LIST_OF_MONTH_FAILURE: 'GET_LIST_OF_MONTH_FAILURE',
  REQUEST_CERTIFY_ALERT: 'REQUEST_CERTIFY_ALERT',
  SUCCESS_CERTIFY_ALERT: 'SUCCESS_CERTIFY_ALERT',
  FAILURE_CERTIFY_ALERT: 'FAILURE_CERTIFY_ALERT',
  RESET_CERTIFY_ALERT: 'RESET_CERTIFY_ALERT',
  LOADING_CERTIFY_ALERT: 'LOADING_CERTIFY_ALERT',

  REQUEST_GET_STATUS_CERTIFY: 'REQUEST_GET_STATUS_CERTIFY',
  SUCCESS_GET_STATUS_CERTIFY: 'SUCCESS_GET_STATUS_CERTIFY',
  FAILURE_GET_STATUS_CERTIFY: 'FAILURE_GET_STATUS_CERTIFY',
  LOADING_GET_STATUS_CERTIFY: 'LOADING_GET_STATUS_CERTIFY',
};

export const getMyAvailabilityConstants = {
  GET_MY_AVAILABILITY_REQUEST: 'GET_MY_AVAILABILITY_REQUEST',
  GET_MY_AVAILABILITY_SUCCESS: 'GET_MY_AVAILABILITY_SUCCESS',
  GET_MY_AVAILABILITY_FAILURE: 'GET_MY_AVAILABILITY_FAILURE',
  GET_MY_AVAILABILITY_RESET: 'GET_MY_AVAILABILITY_RESET',
  GET_MY_AVAILABILITY_LOADING: 'GET_MY_AVAILABILITY_LOADING',
  GET_ALL_PTO_REQUEST: 'GET_ALL_PTO_REQUEST',
  GET_ALL_PTO_SUCCESS: 'GET_ALL_PTO_SUCCESS',
  GET_ALL_PTO_FAILURE: 'GET_ALL_PTO_FAILURE',
  CREATE_PTO_REQUEST_REQUEST: 'CREATE_PTO_REQUEST_REQUEST',
  CREATE_PTO_SUCCESS_REQUEST: 'CREATE_PTO_SUCCESS_REQUEST',
  CREATE_PTO_FAILURE_REQUEST: 'CREATE_PTO_FAILURE_REQUEST',
  CREATE_PTO_RESET_REQUEST: 'CREATE_PTO_RESET_REQUEST',
  REMOVE_PTO_REQ_REQUEST: 'REMOVE_PTO_REQ_REQUEST',
  REMOVE_PTO_REQ_SUCCESS: 'REMOVE_PTO_REQ_SUCCESS',
  REMOVE_PTO_REQ_FAILURE: 'REMOVE_PTO_REQ_FAILURE',
  REMOVE_PTO_REQ_RESET: 'REMOVE_PTO_REQ_RESET',
  REMOVE_PTO_REQ_LOADER: 'REMOVE_PTO_REQ_LOADER',
  EDIT_MY_AVAILABILITY_REQUEST: 'EDIT_MY_AVAILABILITY_REQUEST',
  EDIT_MY_AVAILABILITY_SUCCESS: 'EDIT_MY_AVAILABILITY_SUCCESS',
  EDIT_MY_AVAILABILITY_FAILURE: 'EDIT_MY_AVAILABILITY_FAILURE',
  EDIT_MY_AVAILABILITY_RESET: 'EDIT_MY_AVAILABILITY_RESET',
  EDIT_MY_AVAILABILITY_LOADING: 'EDIT_MY_AVAILABILITY_LOADING',

  GET_LIST_OF_THERAPIST_AVA_REQUEST: 'GET_LIST_OF_THERAPIST_AVA_REQUEST',
  GET_LIST_OF_THERAPIST_AVA_SUCCESS: 'GET_LIST_OF_THERAPIST_AVA_SUCCESS',
  GET_LIST_OF_THERAPIST_AVA_FAILURE: 'GET_LIST_OF_THERAPIST_AVA_FAILURE',
  GET_LIST_OF_THERAPIST_AVA_LOADING: 'GET_LIST_OF_THERAPIST_AVA_LOADING',
  GET_LIST_OF_THERAPIST_AVA_RESET: 'GET_LIST_OF_THERAPIST_AVA_RESET',
};

export const laborHoursConstant = {
  GET_LABOR_HOURS_REQUEST: 'GET_LABOR_HOURS_REQUEST',
  GET_LABOR_HOURS_LOADER: 'GET_LABOR_HOURS_LOADER',
  GET_LABOR_HOURS_SUCCESS: 'GET_LABOR_HOURS_SUCCESS',
  GET_LABOR_HOURS_FAILURE: 'GET_LABOR_HOURS_FAILURE',
  GET_LABOR_HOURS_RESET: 'GET_LABOR_HOURS_RESET',

  GET_LABOR_CODES_REQUEST: 'GET_LABOR_CODES_REQUEST',
  GET_LABOR_CODES_SUCCESS: 'GET_LABOR_CODES_SUCCESS',
  GET_LABOR_CODES_FAILURE: 'GET_LABOR_CODES_FAILURE',

  ADD_LABOR_HOURS_REQUEST: 'ADD_LABOR_HOURS_REQUEST',
  ADD_LABOR_HOURS_LOADER: 'ADD_LABOR_HOURS_LOADER',
  ADD_LABOR_HOURS_SUCCESS: 'ADD_LABOR_HOURS_SUCCESS',
  ADD_LABOR_HOURS_FAILURE: 'ADD_LABOR_HOURS_FAILURE',
  ADD_LABOR_HOURS_RESET: 'ADD_LABOR_HOURS_RESET',

  EDIT_LABOR_HOURS_REQUEST: 'EDIT_LABOR_HOURS_REQUEST',
  EDIT_LABOR_HOURS_LOADER: 'EDIT_LABOR_HOURS_LOADER',
  EDIT_LABOR_HOURS_SUCCESS: 'EDIT_LABOR_HOURS_SUCCESS',
  EDIT_LABOR_HOURS_FAILURE: 'EDIT_LABOR_HOURS_FAILURE',
  EDIT_LABOR_HOURS_RESET: 'EDIT_LABOR_HOURS_RESET',

  GET_LOCATION_TYPE_REQUEST: 'GET_LOCATION_TYPE_REQUEST',
  GET_LOCATION_TYPE_SUCCESS: 'GET_LOCATION_TYPE_SUCCESS',
  GET_LOCATION_TYPE_FAILURE: 'GET_LOCATION_TYPE_FAILURE',
  GET_LOCATION_TYPE_LOADER: 'GET_LOCATION_TYPE_LOADER',

  DELETE_LABOR_HOURS_REQUEST: 'DELETE_LABOR_HOURS_REQUEST',
  DELETE_LABOR_HOURS_LOADER: 'DELETE_LABOR_HOURS_LOADER',
  DELETE_LABOR_HOURS_SUCCESS: 'DELETE_LABOR_HOURS_SUCCESS',
  DELETE_LABOR_HOURS_FAILURE: 'DELETE_LABOR_HOURS_FAILURE',
  DELETE_LABOR_HOURS_RESET: 'DELETE_LABOR_HOURS_RESET',
};

export const addTaskConstant = {
  ADD_TASK_THERAPIST_REQUEST: 'ADD_TASK_THERAPIST_REQUEST',
  ADD_TASK_THERAPIST_SUCCESS: 'ADD_TASK_THERAPIST_SUCCESS',
  ADD_TASK_THERAPIST_FAILURE: 'ADD_TASK_THERAPIST_FAILURE',
  ADD_TASK_THERAPIST_RESET: 'ADD_TASK_THERAPIST_RESET',
  ADD_TASK_THERAPIST_LOADING: 'ADD_TASK_THERAPIST_LOADING',
};

export const unlockTherapistConstant = {
  GET_UNLOCK_THERAPIST_REQUEST: 'GET_UNLOCK_THERAPIST_REQUEST',
  GET_UNLOCK_THERAPIST_SUCCESS: 'GET_UNLOCK_THERAPIST_SUCCESS',
  GET_UNLOCK_THERAPIST_FAILURE: 'GET_UNLOCK_THERAPIST_FAILURE',
  GET_UNLOCK_THERAPIST_RESET: 'GET_UNLOCK_THERAPIST_RESET',
  GET_UNLOCK_THERAPIST_LOADING: 'GET_UNLOCK_THERAPIST_LOADING',

  //update unlock therapist
  POST_UNLOCK_THERAPIST_REQUEST: 'POST_UNLOCK_THERAPIST_REQUEST',
  POST_UNLOCK_THERAPIST_SUCCESS: 'POST_UNLOCK_THERAPIST_SUCCESS',
  POST_UNLOCK_THERAPIST_FAILURE: 'POST_UNLOCK_THERAPIST_FAILURE',
  POST_UNLOCK_THERAPIST_RESET: 'POST_UNLOCK_THERAPIST_RESET',
  POST_UNLOCK_THERAPIST_LOADING: 'POST_UNLOCK_THERAPIST_LOADING',

  //lock daily session notes
  GET_LOCK_DAILY_SESSION_NOTES_REQUEST: 'GET_LOCK_DAILY_SESSION_NOTES_REQUEST',
  GET_LOCK_DAILY_SESSION_NOTES_SUCCESS: 'GET_LOCK_DAILY_SESSION_NOTES_SUCCESS',
  GET_LOCK_DAILY_SESSION_NOTES_FAILURE: 'GET_LOCK_DAILY_SESSION_NOTES_FAILURE',
  GET_LOCK_DAILY_SESSION_NOTES_RESET: 'GET_LOCK_DAILY_SESSION_NOTES_RESET',
  GET_LOCK_DAILY_SESSION_NOTES_LOADING: 'GET_LOCK_DAILY_SESSION_NOTES_LOADING',
};

export const editTaskConstant = {
  EDIT_TASK_THERAPIST_SCHEDULING_REQUEST: 'EDIT_TASK_THERAPIST_SCHEDULING_REQUEST',
  EDIT_TASK_THERAPIST_SCHEDULING_SUCCESS: 'EDIT_TASK_THERAPIST_SCHEDULING_SUCCESS',
  EDIT_TASK_THERAPIST_SCHEDULING_FAILURE: 'EDIT_TASK_THERAPIST_SCHEDULING_FAILURE',
  EDIT_TASK_THERAPIST_SCHEDULING_RESET: 'EDIT_TASK_THERAPIST_SCHEDULING_RESET',
  EDIT_TASK_THERAPIST_SCHEDULING_LOADING: 'EDIT_TASK_THERAPIST_SCHEDULING_LOADING',
};

export const skillListConstant = {
  GET_SKILL_THERAPIST_SCHEDULING_LIST_REQUEST: 'GET_SKILL_THERAPIST_SCHEDULING_LIST_REQUEST',
  GET_SKILL_THERAPIST_SCHEDULING_LIST_SUCCESS: 'GET_SKILL_THERAPIST_SCHEDULING_LIST_SUCCESS',
  GET_SKILL_THERAPIST_SCHEDULING_LIST_FAILURE: 'GET_SKILL_THERAPIST_SCHEDULING_LIST_FAILURE',
};
export const patientDateOfServiceConstant = {
  GET_PATIENT_DATE_OF_SERVICE_REQUEST: 'GET_PATIENT_DATE_OF_SERVICE_REQUEST',
  GET_PATIENT_DATE_OF_SERVICE_SUCCESS: 'GET_PATIENT_DATE_OF_SERVICE_SUCCESS',
  GET_PATIENT_DATE_OF_SERVICE_FAILURE: 'GET_PATIENT_DATE_OF_SERVICE_FAILURE',
};

export const therapistDisciplineList = {
  GET_THERAPIST_DISCIPLINE_LIST_REQUEST: 'GET_THERAPIST_DISCIPLINE_LIST_REQUEST',
  GET_THERAPIST_DISCIPLINE_LIST_SUCCESS: 'GET_THERAPIST_DISCIPLINE_LIST_SUCCESS',
  GET_THERAPIST_DISCIPLINE_LIST_FAILURE: 'GET_THERAPIST_DISCIPLINE_LIST_FAILURE',
};

export const documentationActions = {
  REQUEST_GET_ALL_TEMPLATES: 'REQUEST_GET_ALL_TEMPLATES',
  SUCCESS_GET_ALL_TEMPLATES: 'SUCCESS_GET_ALL_TEMPLATES',
  FAILURE_GET_ALL_TEMPLATES: 'FAILURE_GET_ALL_TEMPLATES',
  REQUEST_CALL_SUBMISSION_EVENT: 'REQUEST_CALL_SUBMISSION_EVENT',
  SUCCESS_CALL_SUBMISSION_EVENT: 'SUCCESS_CALL_SUBMISSION_EVENT',
  FAILURE_CALL_SUBMISSION_EVENT: 'FAILURE_CALL_SUBMISSION_EVENT',
  RESET_CALL_SUBMISSION_EVENT: 'RESET_CALL_SUBMISSION_EVENT',
  REQUEST_GET_ALL_SUBMITTED_DOCUMENT: 'REQUEST_GET_ALL_SUBMITTED_DOCUMENT',
  REQUEST_GET_ALL_SUBMITTED_DOCUMENT_FOR_RESOLVER:
    'REQUEST_GET_ALL_SUBMITTED_DOCUMENT_FOR_RESOLVER',
  SUCCESS_GET_ALL_SUBMITTED_DOCUMENT: 'SUCCESS_GET_ALL_SUBMITTED_DOCUMENT',
  FAILURE_GET_ALL_SUBMITTED_DOCUMENT: 'FAILURE_GET_ALL_SUBMITTED_DOCUMENT',
  RESET_GET_ALL_SUBMITTED_DOCUMENT: 'RESET_GET_ALL_SUBMITTED_DOCUMENT',
  LOADER_GET_ALL_SUBMITTED_DOCUMENT: 'LOADER_GET_ALL_SUBMITTED_DOCUMENT',

  FAILURE_GET_ALL_COMPETED_DOCUMENT: 'FAILURE_GET_ALL_COMPETED_DOCUMENT',
  SUCCESS_GET_ALL_COMPETED_DOCUMENT: 'SUCCESS_GET_ALL_COMPETED_DOCUMENT',
  RESET_GET_ALL_COMPETED_DOCUMENT: 'RESET_GET_ALL_COMPETED_DOCUMENT',
  LOADER_GET_ALL_COMPETED_DOCUMENT: 'LOADER_GET_ALL_COMPETED_DOCUMENT',
  REQUEST_GET_ALL_COMPETED_DOCUMENT: 'REQUEST_GET_ALL_COMPETED_DOCUMENT',

  REQUEST_SUBMITTED_DATA_BY_SUBMISSION_ID: 'REQUEST_SUBMITTED_DATA_BY_SUBMISSION_ID',
  SUCCESS_SUBMITTED_DATA_BY_SUBMISSION_ID: 'SUCCESS_SUBMITTED_DATA_BY_SUBMISSION_ID',
  FAILURE_SUBMITTED_DATA_BY_SUBMISSION_ID: 'FAILURE_SUBMITTED_DATA_BY_SUBMISSION_ID',
  RESET_SUBMITTED_DATA_BY_SUBMISSION_ID: 'RESET_SUBMITTED_DATA_BY_SUBMISSION_ID',
  LOADING_SUBMITTED_DATA_BY_SUBMISSION_ID: 'LOADING_SUBMITTED_DATA_BY_SUBMISSION_ID',
  REQUEST_GET_SIGNATURE_TEMPLATE: 'REQUEST_GET_SIGNATURE_TEMPLATE',
  SUCCESS_GET_SIGNATURE_TEMPLATE: 'SUCCESS_GET_SIGNATURE_TEMPLATE',
  FAILURE_GET_SIGNATURE_TEMPLATE: 'FAILURE_GET_SIGNATURE_TEMPLATE',
  DASHBOARD_SIGNATURE_TEMPLATE: 'DASHBOARD_SIGNATURE_TEMPLATE',
  DASHBOARD_DOC_PREVIEW: 'DASHBOARD_DOC_PREVIEW',
  RESET_GET_SIGNATURE_TEMPLATE: 'RESET_GET_SIGNATURE_TEMPLATE',
  LOADING_GET_SIGNATURE_TEMPLATE: 'LOADING_GET_SIGNATURE_TEMPLATE',
  REQUEST_GET_ALL_MISCELLANEOUS_DOCUMENTS: 'REQUEST_GET_ALL_MISCELLANEOUS_DOCUMENTS',
  SUCCESS_GET_ALL_MISCELLANEOUS_DOCUMENTS: 'SUCCESS_GET_ALL_MISCELLANEOUS_DOCUMENTS',
  FAILURE_GET_ALL_MISCELLANEOUS_DOCUMENTS: 'FAILURE_GET_ALL_MISCELLANEOUS_DOCUMENTS',
  LOADING_GET_ALL_MISCELLANEOUS_DOCUMENTS: 'LOADING_GET_ALL_MISCELLANEOUS_DOCUMENTS',
  REQUEST_SAVE_MISCELLANEOUS_DOCUMENTS: 'REQUEST_SAVE_MISCELLANEOUS_DOCUMENTS',
  SUCCESS_SAVE_MISCELLANEOUS_DOCUMENTS: 'SUCCESS_SAVE_MISCELLANEOUS_DOCUMENTS',
  FAILURE_SAVE_MISCELLANEOUS_DOCUMENTS: 'FAILURE_SAVE_MISCELLANEOUS_DOCUMENTS',
  RESET_SAVE_MISCELLANEOUS_DOCUMENTS: 'RESET_SAVE_MISCELLANEOUS_DOCUMENTS',
  LOADING_SAVE_MISCELLANEOUS_DOCUMENTS: 'LOADING_SAVE_MISCELLANEOUS_DOCUMENTS',
  REQUEST_GET_ALL_SUPERVISIORS: 'REQUEST_GET_ALL_SUPERVISIORS',
  SUCCESS_GET_ALL_SUPERVISIORS: 'SUCCESS_GET_ALL_SUPERVISIORS',
  FAILURE_GET_ALL_SUPERVISIORS: 'FAILURE_GET_ALL_SUPERVISIORS',
  LOADING_GET_ALL_SUPERVISIORS: 'LOADING_GET_ALL_SUPERVISIORS',
  REQUEST_EDIT_SIGN_DOC: 'REQUEST_EDIT_SIGN_DOC',
  SUCCESS_EDIT_SIGN_DOC: 'SUCCESS_EDIT_SIGN_DOC',
  FAILURE_EDIT_SIGN_DOC: 'FAILURE_EDIT_SIGN_DOC',
  LOADING_EDIT_SIGN_DOC: 'LOADING_EDIT_SIGN_DOC',
  RESET_EDIT_SIGN_DOC: 'RESET_EDIT_SIGN_DOC',
  LOADING_SAVE_SUBMISSION: 'LOADING_SAVE_SUBMISSION',
  REQUEST_SEND_MAIL_TO_PHYSICIAN: 'REQUEST_SEND_MAIL_TO_PHYSICIAN',
  SUCCESS_SEND_MAIL_TO_PHYSICIAN: 'SUCCESS_SEND_MAIL_TO_PHYSICIAN',
  FAILURE_SEND_MAIL_TO_PHYSICIAN: 'FAILURE_SEND_MAIL_TO_PHYSICIAN',
  RESET_SEND_MAIL_TO_PHYSICIAN: 'RESET_SEND_MAIL_TO_PHYSICIAN',
  LOADING_SEND_MAIL_TO_PHYSICIAN: 'LOADING_SEND_MAIL_TO_PHYSICIAN',
  REQUEST_GET_ALL_CODES: 'REQUEST_GET_ALL_CODES',
  SUCCESS_GET_ALL_CODES: 'SUCCESS_GET_ALL_CODES',
  FAILURE_GET_ALL_CODES: 'FAILURE_GET_ALL_CODES',
  LOADING_GET_ALL_CODES: 'LOADING_GET_ALL_CODES',
  REQUEST_GET_SIGNATURE_ACCESS: 'REQUEST_GET_SIGNATURE_ACCESS',
  SUCCESS_GET_SIGNATURE_ACCESS: 'SUCCESS_GET_SIGNATURE_ACCESS',
  FAILURE_GET_SIGNATURE_ACCESS: 'FAILURE_GET_SIGNATURE_ACCESS',
  RESET_GET_SIGNATURE_ACCESS: 'RESET_GET_SIGNATURE_ACCESS',
  REQUEST_GET_ALL_CODES_ICD: 'REQUEST_GET_ALL_CODES_ICD',
  SUCCESS_GET_ALL_CODES_ICD: 'SUCCESS_GET_ALL_CODES_ICD',
  FAILURE_GET_ALL_CODES_ICD: 'FAILURE_GET_ALL_CODES_ICD',
  LOADING_GET_ALL_CODES_ICD: 'LOADING_GET_ALL_CODES_ICD',
  PULL_UUID_REQUEST: 'PULL_UUID_REQUEST',
  PULL_UUID_SUCCESS: 'PULL_UUID_SUCCESS',
  PULL_UUID_FAILURE: 'PULL_UUID_FAILURE',
  PULL_UUID_LOADER: 'PULL_UUID_LOADER',
  PULL_UUID_RESET: 'PULL_UUID_RESET',
  REQUEST_REASSIGN_THERAPIST: 'REQUEST_REASSIGN_THERAPIST',
  SUCCESS_REASSIGN_THERAPIST: 'SUCCESS_REASSIGN_THERAPIST',
  FAILURE_REASSIGN_THERAPIST: 'FAILURE_REASSIGN_THERAPIST',
  LOADING_REASSIGN_THERAPIST: 'LOADING_REASSIGN_THERAPIST',
  RESET_REASSIGN_THERAPIST: 'RESET_REASSIGN_THERAPIST',
  REQUEST_GET_PROVIDER_LIST: 'REQUEST_GET_PROVIDER_LIST',
  SUCCESS_GET_PROVIDER_LIST: 'SUCCESS_GET_PROVIDER_LIST',
  FAILURE_GET_PROVIDER_LIST: 'FAILURE_GET_PROVIDER_LIST',
  LOADING_GET_PROVIDER_LIST: 'LOADING_GET_PROVIDER_LIST',
  REQUEST_LOADING_DOCUMENTATION: 'REQUEST_LOADING_DOCUMENTATION',
  SUCCESS_LOADING_DOCUMENTATION: 'SUCCESS_LOADING_DOCUMENTATION',
  ERROR_LOADING_DOCUMENTATION: 'ERROR_LOADING_DOCUMENTATION',
  RESET_LOADING_DOCUMENTATION: 'RESET_LOADING_DOCUMENTATION',
  REQUEST_GET_DOC_PREFILL_URL: 'REQUEST_GET_DOC_PREFILL_URL',
  SUCCESS_GET_DOC_PREFILL_URL: 'SUCCESS_GET_DOC_PREFILL_URL',
  FAILURE_GET_DOC_PREFILL_URL: 'FAILURE_GET_DOC_PREFILL_URL',
  RESET_GET_DOC_PREFILL_URL: 'RESET_GET_DOC_PREFILL_URL',

  //check daily session notes sign
  REQUEST_DAILY_SESSION_NOTES_SIGN: 'REQUEST_DAILY_SESSION_NOTES_SIGN',
  SUCCESS_DAILY_SESSION_NOTES_SIGN: 'SUCCESS_DAILY_SESSION_NOTES_SIGN',
  FAILURE_DAILY_SESSION_NOTES_SIGN: 'FAILURE_DAILY_SESSION_NOTES_SIGN',
  LOADER_DAILY_SESSION_NOTES_SIGN: 'LOADER_DAILY_SESSION_NOTES_SIGN',
  RESET_DAILY_SESSION_NOTES_SIGN: 'RESET_DAILY_SESSION_NOTES_SIGN',

  //get Start of Care Date
  GET_START_OF_CARE_DATE_REQUEST: 'GET_START_OF_CARE_DATE_REQUEST',
  GET_START_OF_CARE_DATE_SUCCUSS: 'GET_START_OF_CARE_DATE_SUCCUSS',
  GET_START_OF_CARE_DATE_FAILURE: 'GET_START_OF_CARE_DATE_FAILURE',
  GET_START_OF_CARE_DATE_LOADING: 'GET_START_OF_CARE_DATE_LOADING',
  GET_START_OF_CARE_DATE_RESET: 'GET_START_OF_CARE_DATE_RESET',

  REQUEST_DELETE_REQUIRED_DOCUMET: 'REQUEST_DELETE_REQUIRED_DOCUMET',
  SUCCESS_DELETE_REQUIRED_DOCUMET: 'SUCCESS_DELETE_REQUIRED_DOCUMET',
  FAILURE_DELETE_REQUIRED_DOCUMET: 'FAILURE_DELETE_REQUIRED_DOCUMET',
  RESET_DELETE_REQUIRED_DOCUMET: 'RESET_DELETE_REQUIRED_DOCUMET',

  REQUEST_PREPARE_PROGREE_NOTE: 'REQUEST_PREPARE_PROGREE_NOTE',
  SUCCESS_PREPARE_PROGREE_NOTE: 'SUCCESS_PREPARE_PROGREE_NOTE',
  FAILURE_PREPARE_PROGREE_NOTE: 'FAILURE_PREPARE_PROGREE_NOTE',
  RESET_PREPARE_PROGREE_NOTE: 'RESET_PREPARE_PROGREE_NOTE',

  SUCCESS_CHECK_PHYSICIAN: 'SUCCESS_CHECK_PHYSICIAN',
  REQUEST_CHECK_PHYSICIAN: 'REQUEST_CHECK_PHYSICIAN',
  FAILURE_CHECK_PHYSICIAN: 'FAILURE_CHECK_PHYSICIAN',
  RESET_CHECK_PHYSICIAN: 'RESET_CHECK_PHYSICIAN',
  LOADING_CHECK_PHYSICIAN: 'LOADING_CHECK_PHYSICIAN',
  //navigation prevent
  SET_NAVIGATION_FORM: 'SET_NAVIGATION_FORM',
  RESET_NAVIGATION_FORM: 'RESET_NAVIGATION_FORM',

  GET_DASHBOARD_DOCUMENT_DATA: 'GET_DASHBOARD_DOCUMENT_DATA',
  RESET_DASHBOARD_DOCUMENT_DATA: 'RESET_DASHBOARD_DOCUMENT_DATA',

  GET_EOC_CREATE_DOCUMENT_DATA: 'GET_EOC_CREATE_DOCUMENT_DATA',
  RESET_EOC_CREATE_DOCUMENT_DATA: 'RESET_EOC_CREATE_DOCUMENT_DATA',

  GET_EOC_EDIT_DOCUMENT_DATA: 'GET_EOC_EDIT_DOCUMENT_DATA',
  RESET_EOC_EDIT_DOCUMENT_DATA: 'RESET_EOC_EDIT_DOCUMENT_DATA',

  //check is reform
  IS_CHECK_DOCUMENT_REFORM: 'IS_CHECK_DOCUMENT_REFORM',

  //check discharge
  CHECK_DISCHARGE_ALLOWS_REQUEST: 'CHECK_DISCHARGE_ALLOWS_REQUEST',
  CHECK_DISCHARGE_ALLOWS_SUCCESS: 'CHECK_DISCHARGE_ALLOWS_SUCCESS',
  CHECK_DISCHARGE_ALLOWS_FAILURE: 'CHECK_DISCHARGE_ALLOWS_FAILURE',
  CHECK_DISCHARGE_ALLOWS_LOADING: 'CHECK_DISCHARGE_ALLOWS_LOADING',
  CHECK_DISCHARGE_ALLOWS_RESET: 'CHECK_DISCHARGE_ALLOWS_RESET',

  //check pending docs alert
  CHECK_PENDING_DOCS_ALERT_REQUEST: 'CHECK_PENDING_DOCS_ALERT_REQUEST',
  CHECK_PENDING_DOCS_ALERT_SUCCESS: 'CHECK_PENDING_DOCS_ALERT_SUCCESS',
  CHECK_PENDING_DOCS_ALERT_FAILURE: 'CHECK_PENDING_DOCS_ALERT_FAILURE',
  CHECK_PENDING_DOCS_ALERT_RESET: 'CHECK_PENDING_DOCS_ALERT_RESET',

  // new sign documents
  NEW_DOCUMENT_SIGN_REQUEST: 'NEW_DOCUMENT_SIGN_REQUEST',
  NEW_DOCUMENT_SIGN_LOADING: 'NEW_DOCUMENT_SIGN_LOADING',
  NEW_DOCUMENT_SIGN_SUCCESS: 'NEW_DOCUMENT_SIGN_SUCCESS',
  NEW_DOCUMENT_SIGN_FAILURE: 'NEW_DOCUMENT_SIGN_FAILURE',
  NEW_DOCUMENT_SIGN_RESET: '  NEW_DOCUMENT_SIGN_RESET',

  UNDO_DOCUMENT_SIGN_REQUEST: 'UNDO_DOCUMENT_SIGN_REQUEST',
  UNDO_DOCUMENT_SIGN_LOADING: 'UNDO_DOCUMENT_SIGN_LOADING',
  UNDO_DOCUMENT_SIGN_SUCCESS: 'UNDO_DOCUMENT_SIGN_SUCCESS',
  UNDO_DOCUMENT_SIGN_FAILURE: 'UNDO_DOCUMENT_SIGN_FAILURE',
  UNDO_DOCUMENT_SIGN_RESET: '  UNDO_DOCUMENT_SIGN_RESET',

  // get due document setting
  REQUEST_DUE_DOCUMENT_SETTING_REQUEST: 'REQUEST_DUE_DOCUMENT_SETTING_REQUEST',
  REQUEST_DUE_DOCUMENT_SETTING_SUCCESS: 'REQUEST_DUE_DOCUMENT_SETTING_SUCCESS',
  REQUEST_DUE_DOCUMENT_SETTING_FAILURE: 'REQUEST_DUE_DOCUMENT_SETTING_FAILURE',
  REQUEST_DUE_DOCUMENT_SETTING_RESET: 'REQUEST_DUE_DOCUMENT_SETTING_RESET',
  REQUEST_DUE_DOCUMENT_SETTING_LOADING: 'REQUEST_DUE_DOCUMENT_SETTING_LOADING',
};

export const dailySessionNotes = {
  GET_PATIENT_DAILY_SESSION_REQUEST: 'GET_PATIENT_DAILY_SESSION_REQUEST',
  GET_PATIENT_DAILY_SESSION_SUCCESS: 'GET_PATIENT_DAILY_SESSION_SUCCESS',
  GET_PATIENT_DAILY_SESSION_FAILURE: 'GET_PATIENT_DAILY_SESSION_FAILURE',
  GET_PATIENT_DAILY_SESSION_LOADING: 'GET_PATIENT_DAILY_SESSION_LOADING',
  RESET_PATIENT_DAILY_SESSION: 'RESET_PATIENT_DAILY_SESSION',
  GET_OTHER_PATIENT_DAILY_SESSION_REQUEST: 'GET_OTHER_PATIENT_DAILY_SESSION_REQUEST',
  GET_OTHER_PATIENT_DAILY_SESSION_SUCCESS: 'GET_OTHER_PATIENT_DAILY_SESSION_SUCCESS',
  GET_OTHER_PATIENT_DAILY_SESSION_FAILURE: 'GET_OTHER_PATIENT_DAILY_SESSION_FAILURE',
  GET_OTHER_PATIENT_DAILY_SESSION_LOADING: 'GET_OTHER_PATIENT_DAILY_SESSION_LOADING',
  RESET_OTHER_PATIENT_DAILY_SESSION: 'RESET_OTHER_PATIENT_DAILY_SESSION',
  PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_REQUEST:
    'PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_REQUEST',
  PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_SUCCESS:
    'PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_SUCCESS',
  PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_FAILURE:
    'PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_FAILURE',
  SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_LOADING:
    'PUT_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION_LOADING',
  RESET_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION: 'RESET_SOAP_NOTES_OTHER_PATIENT_DAILY_SESSION',
  GET_PATIENT_INFO_DAILY_SESSION_REQUEST: 'GET_PATIENT_INFO_DAILY_SESSION_REQUEST',
  GET_PATIENT_INFO_DAILY_SESSION_SUCCESS: 'GET_PATIENT_INFO_DAILY_SESSION_SUCCESS',
  GET_PATIENT_INFO_DAILY_SESSION_FAILURE: 'GET_PATIENT_INFO_DAILY_SESSION_FAILURE',
  GET_PATIENT_INFO_DAILY_SESSION_LOADING: 'GET_PATIENT_INFO_DAILY_SESSION_LOADING',
  GET_DAILY_SESSION_NOTES_REQUEST: 'GET_DAILY_SESSION_NOTES_REQUEST',
  GET_DAILY_SESSION_NOTES_SUCCESS: 'GET_DAILY_SESSION_NOTES_SUCCESS',
  GET_DAILY_SESSION_NOTES_FAILURE: 'GET_DAILY_SESSION_NOTES_FAILURE',
  GET_DAILY_SESSION_NOTES_LOADING: 'GET_DAILY_SESSION_NOTES_LOADING',
  GET_DAILY_SESSION_NOTES_RESET: 'GET_DAILY_SESSION_NOTES_RESET',
  UPDATE_DAILY_SESSION_NOTES_REQUEST: 'UPDATE_DAILY_SESSION_NOTES_REQUEST',
  UPDATE_DAILY_SESSION_NOTES_SUCCESS: 'UPDATE_DAILY_SESSION_NOTES_SUCCESS',
  UPDATE_DAILY_SESSION_NOTES_FAILURE: 'UPDATE_DAILY_SESSION_NOTES_FAILURE',
  RESET_UPDATE_DAILY_SESSION_NOTES: 'RESET_UPDATE_DAILY_SESSION_NOTES',
  REQUEST_GET_NOTE_TEMPLATE: 'REQUEST_GET_NOTE_TEMPLATE',
  SUCCESS_GET_NOTE_TEMPLATE: 'SUCCESS_GET_NOTE_TEMPLATE',
  FAILURE_GET_NOTE_TEMPLATE: 'FAILURE_GET_NOTE_TEMPLATE',
  LOADING_GET_NOTE_TEMPLATE: 'LOADING_GET_NOTE_TEMPLATE',
  RESET_GET_NOTE_TEMPLATE: 'RESET_GET_NOTE_TEMPLATE',
  REQUEST_UPDATE_NOTE: 'REQUEST_UPDATE_NOTE',
  SUCCESS_UPDATE_NOTE: 'SUCCESS_UPDATE_NOTE',
  FAILURE_UPDATE_NOTE: 'FAILURE_UPDATE_NOTE',
  LOADING_UPDATE_NOTE: 'LOADING_UPDATE_NOTE',
  RESET_UPDATE_NOTE: 'RESET_UPDATE_NOTE',
  REQUEST_SUBMIT_E_SIGN: 'REQUEST_SUBMIT_E_SIGN',
  SUCCESS_SUBMIT_E_SIGN: 'SUCCESS_SUBMIT_E_SIGN',
  FAILURE_SUBMIT_E_SIGN: 'FAILURE_SUBMIT_E_SIGN',
  RESET_SUBMIT_E_SIGN: 'RESET_SUBMIT_E_SIGN',
  LOADING_SUBMIT_E_SIGN: 'LOADING_SUBMIT_E_SIGN',
};

export const patientDeleteTask = {
  DELETE_PATIENT_TASK_REQUEST: 'DELETE_PATIENT_TASK_REQUEST',
  DELETE_PATIENT_TASK_SUCCESS: 'DELETE_PATIENT_TASK_SUCCESS',
  DELETE_PATIENT_TASK_FAILURE: 'DELETE_PATIENT_TASK_FAILURE',
  DELETE_PATIENT_TASK_LOADER: 'DELETE_PATIENT_TASK_LOADER',
  RESET_DELETE_PATIENT_TASK: 'RESET_DELETE_PATIENT_TASK',
};

export const DashboardConstants = {
  //patient list
  GET_DASHBOARD_PATIENT_LIST_REQUEST: 'GET_DASHBOARD_PATIENT_LIST_REQUEST',
  GET_DASHBOARD_PATIENT_LIST_SUCCESS: 'GET_DASHBOARD_PATIENT_LIST_SUCCESS',
  GET_DASHBOARD_PATIENT_LIST_FAILURE: 'GET_DASHBOARD_PATIENT_LIST_FAILURE',
  GET_DASHBOARD_PATIENT_LIST_LOADER: 'GET_DASHBOARD_PATIENT_LIST_LOADER',

  //document  management
  GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_REQUEST: 'GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_REQUEST',
  GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_SUCCESS: 'GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_SUCCESS',
  GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_FAILURE: 'GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_FAILURE',
  GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_LOADER: 'GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_LOADER',
  GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_RESET: 'GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_RESET',

  //document  management csv
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_REQUEST:
    'GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_REQUEST',
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_SUCCESS:
    'GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_SUCCESS',
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_FAILURE:
    'GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_FAILURE',
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_LOADER:
    'GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_LOADER',
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_RESET: 'GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_RESET',

  //overview of task

  GET_DASHBOARD_OVERVIEW_REQUEST: 'GET_DASHBOARD_OVERVIEW_REQUEST',
  GET_DASHBOARD_OVERVIEW_SUCCESS: 'GET_DASHBOARD_OVERVIEW_SUCCESS',
  GET_DASHBOARD_OVERVIEW_FAILURE: 'GET_DASHBOARD_OVERVIEW_FAILURE',
  GET_DASHBOARD_OVERVIEW_LOADER: 'GET_DASHBOARD_OVERVIEW_LOADER',
  GET_DASHBOARD_THERAPY_REQUEST: 'GET_DASHBOARD_THERAPY_REQUEST',
  GET_DASHBOARD_THERAPY_SUCCESS: 'GET_DASHBOARD_THERAPY_SUCCESS',
  GET_DASHBOARD_THERAPY_FAILURE: 'GET_DASHBOARD_THERAPY_FAILURE',
  GET_DASHBOARD_THERAPY_LOADER: 'GET_DASHBOARD_THERAPY_LOADER',
  GET_DASHBOARD_DOCUMENTATION_REQUEST: 'GET_DASHBOARD_DOCUMENTATION_REQUEST',
  GET_DASHBOARD_DOCUMENTATION_SUCCESS: 'GET_DASHBOARD_DOCUMENTATION_SUCCESS',
  GET_DASHBOARD_DOCUMENTATION_FAILURE: 'GET_DASHBOARD_DOCUMENTATION_FAILURE',
  GET_DASHBOARD_DOCUMENTATION_LOADER: 'GET_DASHBOARD_DOCUMENTATION_LOADER',

  //get time in
  GET_DASHBOARD_TIME_IN_REQUEST: 'GET_DASHBOARD_TIME_IN_REQUEST',
  GET_DASHBOARD_TIME_IN_SUCCESS: 'GET_DASHBOARD_TIME_IN_SUCCESS',
  GET_DASHBOARD_TIME_IN_FAILURE: 'GET_DASHBOARD_TIME_IN_FAILURE',
  GET_DASHBOARD_TIME_IN_LOADER: 'GET_DASHBOARD_TIME_IN_LOADER',
  GET_DASHBOARD_TIME_IN_RESET: 'GET_DASHBOARD_TIME_IN_RESET',
  RESET_HARD_CLOCK_IN: 'RESET_HARD_CLOCK_IN',

  //post check out
  POST_DASHBOARD_CHECKOUT_REQUEST: 'POST_DASHBOARD_CHECKOUT_REQUEST',
  POST_DASHBOARD_CHECKOUT_SUCCESS: 'POST_DASHBOARD_CHECKOUT_SUCCESS',
  POST_DASHBOARD_CHECKOUT_FAILURE: 'POST_DASHBOARD_CHECKOUT_FAILURE',
  POST_DASHBOARD_CHECKOUT_LOADER: 'POST_DASHBOARD_CHECKOUT_LOADER',
  POST_DASHBOARD_CHECKOUT_RESET: 'POST_DASHBOARD_CHECKOUT_RESET',
  POST_DASHBOARD_CHECKOUT_RESET_LOGOUT: 'POST_DASHBOARD_CHECKOUT_RESET_LOGOUT',
  CLOCK_ACTION: 'CLOCK_ACTION',
  POST_CHECKOUT_ACTION_RESET: 'POST_CHECKOUT_ACTION_RESET',

  //get patient details
  GET_DASHBOARD_PATIENT_DETAILS_REQUEST: 'GET_DASHBOARD_PATIENT_DETAILS_REQUEST',
  GET_DASHBOARD_PATIENT_DETAILS_SUCCESS: 'GET_DASHBOARD_PATIENT_DETAILS_SUCCESS',
  GET_DASHBOARD_PATIENT_DETAILS_FAILURE: 'GET_DASHBOARD_PATIENT_DETAILS_FAILURE',
  GET_DASHBOARD_PATIENT_DETAILS_LOADER: 'GET_DASHBOARD_PATIENT_DETAILS_LOADER',
  GET_DASHBOARD_PATIENT_DETAILS_RESET: 'GET_DASHBOARD_PATIENT_DETAILS_RESET',

  //get pto latest update

  GET_DASHBOARD_PTO_UPDATE_REQUEST: 'GET_DASHBOARD_PTO_UPDATE_REQUEST',
  GET_DASHBOARD_PTO_UPDATE_SUCCESS: 'GET_DASHBOARD_PTO_UPDATE_SUCCESS',
  GET_DASHBOARD_PTO_UPDATE_FAILURE: 'GET_DASHBOARD_PTO_UPDATE_FAILURE',
  GET_DASHBOARD_PTO_UPDATE_LOADER: 'GET_DASHBOARD_PTO_UPDATE_LOADER',
  GET_DASHBOARD_PTO_UPDATE_RESET: 'GET_DASHBOARD_PTO_UPDATE_RESET',

  //get intervention group

  GET_INTERVENTION_GROUP_REQUEST: 'GET_INTERVENTION_GROUP_REQUEST',
  GET_INTERVENTION_GROUP_SUCCESS: 'GET_INTERVENTION_GROUP_SUCCESS',
  GET_INTERVENTION_GROUP_FAILURE: 'GET_INTERVENTION_GROUP_FAILURE',
  GET_INTERVENTION_GROUP_LOADER: 'GET_INTERVENTION_GROUP_LOADER',
  GET_INTERVENTION_GROUP_RESET: 'GET_INTERVENTION_GROUP_RESET',

  //get game by intervention

  GET_GAME_BY_INTERVENTION_REQUEST: 'GET_GAME_BY_INTERVENTION_REQUEST',
  GET_GAME_BY_INTERVENTION_SUCCESS: 'GET_GAME_BY_INTERVENTION_SUCCESS',
  GET_GAME_BY_INTERVENTION_FAILURE: 'GET_GAME_BY_INTERVENTION_FAILURE',
  GET_GAME_BY_INTERVENTION_LOADER: 'GET_GAME_BY_INTERVENTION_LOADER',
  GET_GAME_BY_INTERVENTION_RESET: 'GET_GAME_BY_INTERVENTION_RESET',

  //auto clock out call
  GET_AUTO_CLOCK_OUT_CALL_REQUEST: 'GET_AUTO_CLOCK_OUT_CALL_REQUEST',
  GET_AUTO_CLOCK_OUT_CALL_SUCCESS: 'GET_AUTO_CLOCK_OUT_CALL_SUCCESS',
  GET_AUTO_CLOCK_OUT_CALL_FAILURE: 'GET_AUTO_CLOCK_OUT_CALL_FAILURE',

  REQUEST_SYNC_ALERTS_FROM_SIGNATURE: 'REQUEST_SYNC_ALERTS_FROM_SIGNATURE',

  // loggen in therapist's daily updates

  GET_THERAPIST_DAILY_UPDATES_REQUEST: 'GET_THERAPIST_DAILY_UPDATES_REQUEST',
  GET_THERAPIST_DAILY_UPDATES_SUCCESS: 'GET_THERAPIST_DAILY_UPDATES_SUCCESS',
  GET_THERAPIST_DAILY_UPDATES_FAILURE: 'GET_THERAPIST_DAILY_UPDATES_FAILURE',
  GET_THERAPIST_DAILY_UPDATES_RESET: 'GET_THERAPIST_DAILY_UPDATES_RESET',
};

export const commonActions = {
  STORE_SUBDOMAIN_REDUX: 'STORE_SUBDOMAIN_REDUX',
  RESET_SUBDOMAIN_REDUX: 'RESET_SUBDOMAIN_REDUX',
};

export const schedulingTask = {
  //create note
  CREATE_TASK_NOTE_SCHEDULING_REQUEST: 'CREATE_TASK_NOTE_SCHEDULING_REQUEST',
  CREATE_TASK_NOTE_SCHEDULING_SUCCESS: 'CREATE_TASK_NOTE_SCHEDULING_SUCCESS',
  CREATE_TASK_NOTE_SCHEDULING_FAILURE: 'CREATE_TASK_NOTE_SCHEDULING_FAILURE',
  CREATE_TASK_NOTE_SCHEDULING_LOADING: 'CREATE_TASK_NOTE_SCHEDULING_LOADING',
  CREATE_TASK_NOTE_SCHEDULING_RESET: 'CREATE_TASK_NOTE_SCHEDULING_RESET',

  // GET NOTE
  GET_TASK_NOTE_SCHEDULING_REQUEST: 'GET_TASK_NOTE_SCHEDULING_REQUEST',
  GET_TASK_NOTE_SCHEDULING_SUCCESS: 'GET_TASK_NOTE_SCHEDULING_SUCCESS',
  GET_TASK_NOTE_SCHEDULING_FAILURE: 'GET_TASK_NOTE_SCHEDULING_FAILURE',
  GET_TASK_NOTE_SCHEDULING_LOADING: 'GET_TASK_NOTE_SCHEDULING_LOADING',
  GET_TASK_NOTE_SCHEDULING_RESET: 'GET_TASK_NOTE_SCHEDULING_RESET',

  DELETE_TASK_NOTE_SCHEDULING_REQUEST: 'DELETE_TASK_NOTE_SCHEDULING_REQUEST',
  DELETE_TASK_NOTE_SCHEDULING_SUCCESS: 'DELETE_TASK_NOTE_SCHEDULING_SUCCESS',
  DELETE_TASK_NOTE_SCHEDULING_FAILURE: 'DELETE_TASK_NOTE_SCHEDULING_FAILURE',
  DELETE_TASK_NOTE_SCHEDULING_LOADING: 'DELETE_TASK_NOTE_SCHEDULING_LOADING',
  DELETE_TASK_NOTE_SCHEDULING_RESET: 'DELETE_TASK_NOTE_SCHEDULING_RESET',
};

export const mdsCommunicationActions = {
  REQUEST_GET_FORM_ID: 'REQUEST_GET_FORM_ID',
  SUCCESS_GET_FORM_ID: 'SUCCESS_GET_FORM_ID',
  FAILURE_GET_FORM_ID: 'FAILURE_GET_FORM_ID',
  RESET_GET_FORM_ID: 'RESET_GET_FORM_ID',
  REQUEST_GET_ALL_MDS_FORM: 'REQUEST_GET_ALL_MDS_FORM',
  SUCCESS_GET_ALL_MDS_FORM: 'SUCCESS_GET_ALL_MDS_FORM',
  FAILURE_GET_ALL_MDS_FORM: 'FAILURE_GET_ALL_MDS_FORM',
  REQUEST_ADD_SIGNER_TO_MDS_FORM: 'REQUEST_ADD_SIGNER_TO_MDS_FORM',
  SUCCESS_ADD_SIGNER_TO_MDS_FORM: 'SUCCESS_ADD_SIGNER_TO_MDS_FORM',
  FAILURE_ADD_SIGNER_TO_MDS_FORM: 'FAILURE_ADD_SIGNER_TO_MDS_FORM',
  RESET_ADD_SIGNER_TO_MDS_FORM: 'RESET_ADD_SIGNER_TO_MDS_FORM',
  REQUEST_SIGN_MDS_FORM: 'REQUEST_SIGN_MDS_FORM',
  SUCCESS_SIGN_MDS_FORM: 'SUCCESS_SIGN_MDS_FORM',
  FAILURE_SIGN_MDS_FORM: 'FAILURE_SIGN_MDS_FORM',
  RESET_SIGN_MDS_FORM: 'RESET_SIGN_MDS_FORM',
  REQUEST_GET_MDS_FORM_BY_ID: 'REQUEST_GET_MDS_FORM_BY_ID',
  SUCCESS_GET_MDS_FORM_BY_ID: 'SUCCESS_GET_MDS_FORM_BY_ID',
  FAILURE_GET_MDS_FORM_BY_ID: 'FAILURE_GET_MDS_FORM_BY_ID',
  REQUEST_GET_MDS_TYPE: 'REQUEST_GET_MDS_TYPE',
  SUCCESS_GET_MDS_TYPE: 'SUCCESS_GET_MDS_TYPE',
  FAILURE_GET_MDS_TYPE: 'FAILURE_GET_MDS_TYPE',
  REQUEST_GET_MDS_REFORM_ID: 'REQUEST_GET_MDS_REFORM_ID',
  SUCCESS_GET_MDS_REFORM_ID: 'SUCCESS_GET_MDS_REFORM_ID',
  FAILURE_GET_MDS_REFORM_ID: 'FAILURE_GET_MDS_REFORM_ID',
  RESET_GET_MDS_REFORM_ID: 'RESET_GET_MDS_REFORM_ID',
};

export const copyTextBankActions = {
  REQUEST_SEARCH_CPT_CODES: 'REQUEST_SEARCH_CPT_CODES',
  SUCCESS_SEARCH_CPT_CODES: 'SUCCESS_SEARCH_CPT_CODES',
  FAILURE_SEARCH_CPT_CODES: 'FAILURE_SEARCH_CPT_CODES',
};

export const PhysicianActions = {
  //GET all signature list

  REQUEST_GET_ALL_PHYSICIAN_DOCUMENTS: 'REQUEST_GET_ALL_PHYSICIAN_DOCUMENTS',
  SUCCESS_GET_ALL_PHYSICIAN_DOCUMENTS: 'SUCCESS_GET_ALL_PHYSICIAN_DOCUMENTS',
  FAILURE_GET_ALL_PHYSICIAN_DOCUMENTS: 'FAILURE_GET_ALL_PHYSICIAN_DOCUMENTS',
  LOADING_GET_ALL_PHYSICIAN_DOCUMENTS: 'LOADING_GET_ALL_PHYSICIAN_DOCUMENTS',
  RESET_GET_ALL_PHYSICIAN_DOCUMENTS: 'RESET_GET_ALL_PHYSICIAN_DOCUMENTS',

  //GET all completed signature list

  REQUEST_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS: 'REQUEST_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS',
  SUCCESS_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS: 'SUCCESS_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS',
  FAILURE_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS: 'FAILURE_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS',
  LOADING_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS: 'LOADING_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS',
  RESET_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS: 'RESET_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS',

  // get all facilities
  GET_ALL_FACILITY_REQUEST: 'GET_ALL_FACILITY_REQUEST',
  GET_ALL_FACILITY_SUCCESS: 'GET_ALL_FACILITY_SUCCESS',
  GET_ALL_FACILITY_LOADER: 'GET_ALL_FACILITY_LOADER',
  GET_ALL_FACILITY_FAILURE: 'GET_ALL_FACILITY_FAILURE',
  GET_ALL_FACILITY_RESET: 'GET_ALL_FACILITY_RESET',

  //get All patient by entriseprise

  GET_ALL_PATIENT_BY_ENTERPRISE_REQUEST: 'GET_ALL_PATIENT_BY_ENTERPRISE_REQUEST',
  GET_ALL_PATIENT_BY_ENTERPRISE_SUCCESS: 'GET_ALL_PATIENT_BY_ENTERPRISE_SUCCESS',
  GET_ALL_PATIENT_BY_ENTERPRISE_FAILURE: 'GET_ALL_PATIENT_BY_ENTERPRISE_FAILURE',
  GET_ALL_PATIENT_BY_ENTERPRISE_RESET: 'GET_ALL_PATIENT_BY_ENTERPRISE_RESET',
  GET_ALL_PATIENT_BY_ENTERPRISE_LOADING: 'GET_ALL_PATIENT_BY_ENTERPRISE_LOADING',

  UPDATE_DOCUMENT_STATUSES_REQUEST: 'UPDATE_DOCUMENT_STATUSES_REQUEST',
  UPDATE_DOCUMENT_STATUSES_LOADING: 'UPDATE_DOCUMENT_STATUSES_LOADING',
  UPDATE_DOCUMENT_STATUSES_SUCCESS: 'UPDATE_DOCUMENT_STATUSES_SUCCESS',
  UPDATE_DOCUMENT_STATUSES_FAILURE: 'UPDATE_DOCUMENT_STATUSES_FAILURE',
  UPDATE_DOCUMENT_STATUSES_RESET: 'UPDATE_DOCUMENT_STATUSES_RESET',
};
